webpackJsonp([27],{

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOKEN; });
/* unused harmony export EXPIRES_ON */
/* unused harmony export EXPIRES_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_ID; });
/* unused harmony export EMP_ID */
/* unused harmony export FULL_NAME */
/* unused harmony export ROLE */
/* unused harmony export EMAIL */
/* unused harmony export O365_TOKEN */
/* unused harmony export USER_IMAGE */
/* unused harmony export USERNAME */
/* unused harmony export DEVICE_ADMIN */
/* unused harmony export IS_ADMIN */
/* unused harmony export STATION_DISPLAY */
/* unused harmony export PICKING_DISPLAY */
/* unused harmony export REPORT_AS_FINISH_DISPLAY */
/* unused harmony export JOB_CARD_DISPLAY */
/* unused harmony export WARE_HOUSE_DISPLAY */
/* unused harmony export STATION_NAME_DISPLAY */
/* unused harmony export DISPLAY_SETTINGS */
/* unused harmony export DEVICE_ID */
/* unused harmony export DEVICE_NAME */
/* unused harmony export DISPLAY_NAME */
/* unused harmony export TABLE_NAME_ACTIVE */
/* unused harmony export URL_INCOMING */
/* harmony export (immutable) */ __webpack_exports__["d"] = authenticationDevice;
/* harmony export (immutable) */ __webpack_exports__["c"] = authentication;
/* harmony export (immutable) */ __webpack_exports__["r"] = setO365TokenCookie;
/* unused harmony export getO365Token */
/* harmony export (immutable) */ __webpack_exports__["t"] = setUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["p"] = getUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = getAllCookies;
/* harmony export (immutable) */ __webpack_exports__["n"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["l"] = getFullName;
/* unused harmony export getDeviceId */
/* harmony export (immutable) */ __webpack_exports__["j"] = getDeviceInfoCookie;
/* unused harmony export getRole */
/* unused harmony export getExpireDate */
/* harmony export (immutable) */ __webpack_exports__["i"] = getDeviceAdmin;
/* harmony export (immutable) */ __webpack_exports__["m"] = getIsAdmin;
/* harmony export (immutable) */ __webpack_exports__["e"] = authenticationEmpMode;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAllCookiesDisplay;
/* unused harmony export setCookieDisplay */
/* unused harmony export clearCookieDisplay */
/* harmony export (immutable) */ __webpack_exports__["q"] = setDisplayName;
/* harmony export (immutable) */ __webpack_exports__["k"] = getDisplayName;
/* harmony export (immutable) */ __webpack_exports__["s"] = setTableNameActive;
/* unused harmony export getTableNameActive */
/* unused harmony export setUrlIncoming */
/* harmony export (immutable) */ __webpack_exports__["o"] = getUrlIncoming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var EXPIRES_DATE = 'expires_date';
var USER_ID = 'user_id';
var EMP_ID = 'emp_id';
var FULL_NAME = 'fullname';
var ROLE = 'role';
var EMAIL = 'email';
var O365_TOKEN = 'o365_token';
var USER_IMAGE = 'user_image';
var USERNAME = 'username';
var DEVICE_ADMIN = 'DEVICE_ADMIN';
var IS_ADMIN = 'is_admin';
var STATION_DISPLAY = 'station_display';
var PICKING_DISPLAY = 'picking_display';
var REPORT_AS_FINISH_DISPLAY = 'report_as_finish_display';
var JOB_CARD_DISPLAY = 'job_card_display';
var WARE_HOUSE_DISPLAY = 'ware_house_display';
var STATION_NAME_DISPLAY = 'station_name_display';
var DISPLAY_SETTINGS = 'display_settings';
var DEVICE_ID = 'deviceId';
var DEVICE_NAME = 'deviceName';

var DISPLAY_NAME = 'display_name';
var TABLE_NAME_ACTIVE = 'table_name_active';
var URL_INCOMING = 'url_incoming';
function getCookie(key) {
    try {
        var value = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(key);
        var setValue = '';

        if (value && typeof value === 'string') {
            setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.decode(value);
        }

        return setValue;
    } catch (error) {
        return null;
    }
}

function setCookie(key, value, expires) {
    var valueToString = String(value);
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.encode(valueToString);
    }
    if (expires && typeof expires === 'number' && expires > 0) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue, { expires: expires });
    } else {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue);
    }
}

function removeCookie(key) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove(key);
}
function authenticationDevice(responseData) {
    var _responseData$data = responseData.data,
        token = _responseData$data.token,
        expiresOn = _responseData$data.expiresOn,
        expiresDate = _responseData$data.expiresDate,
        name = _responseData$data.name,
        deviceId = _responseData$data.deviceId;

    clearToken();
    setCookie(FULL_NAME, null);
    setCookie(EMAIL, null);
    setCookie(USER_ID, null);

    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    setCookie(DEVICE_ADMIN, true);
    setCookie(IS_ADMIN, true);
    setCookie(DEVICE_ID, deviceId);
    setCookie(DEVICE_NAME, name);
}

function authentication(dataAuth, isRemember) {
    var _dataAuth$user = dataAuth.user,
        username = _dataAuth$user.username,
        email = _dataAuth$user.email,
        fullName = _dataAuth$user.fullName,
        id = _dataAuth$user.id,
        deviceAdmin = _dataAuth$user.deviceAdmin,
        isAdmin = _dataAuth$user.isAdmin,
        token = dataAuth.token,
        expiresDate = dataAuth.expiresDate,
        expiresOn = dataAuth.expiresOn;


    clearToken();
    setCookie(FULL_NAME, fullName);
    setCookie(EMAIL, email);
    setCookie(USER_ID, id);
    setCookie(USERNAME, username);

    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    setCookie(DEVICE_ADMIN, deviceAdmin);
    setCookie(IS_ADMIN, isAdmin);
}
function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data);
}
function getO365Token() {
    return getCookie(O365_TOKEN);
}

function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data);
}
function getUserImageCookie() {
    return getCookie(USER_IMAGE);
}
function clearToken() {
    removeCookie(TOKEN);
    removeCookie(EXPIRES_DATE);
    removeCookie(USER_ID);
    removeCookie(FULL_NAME);
    removeCookie(EMAIL);
    removeCookie(IS_ADMIN);
    removeCookie(DEVICE_ADMIN);
    removeCookie(URL_INCOMING);
    removeCookie(DEVICE_ID);
    removeCookie(DEVICE_ADMIN);
    removeCookie(DEVICE_NAME);
    removeCookie(USERNAME);
}

function getAllCookies() {
    var _ref;

    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, EXPIRES_ON, getCookie(EXPIRES_ON)), _defineProperty(_ref, EXPIRES_DATE, getCookie(EXPIRES_DATE)), _defineProperty(_ref, USER_ID, getCookie(USER_ID)), _defineProperty(_ref, DEVICE_ADMIN, getCookie(DEVICE_ADMIN)), _defineProperty(_ref, IS_ADMIN, getCookie(IS_ADMIN)), _defineProperty(_ref, USERNAME, getCookie(USERNAME)), _ref;
}

function getToken() {
    return getCookie(TOKEN);
}

function getFullName() {
    return getCookie(FULL_NAME);
}

function getDeviceId() {
    return getCookie(DEVICE_ID);
}
function getDeviceInfoCookie() {
    return {
        DEVICE_NAME: getCookie(DEVICE_NAME),
        DEVICE_ADMIN: getCookie(DEVICE_ADMIN),
        DEVICE_ID: getCookie(DEVICE_ID)
    };
}

function getRole() {
    return getCookie(ROLE);
}

function getExpireDate() {
    return getCookie(EXPIRES_DATE);
}

function getDeviceAdmin() {
    return getCookie(DEVICE_ADMIN);
}

function getIsAdmin() {
    return getCookie(IS_ADMIN);
}

function authenticationEmpMode(dataAuth, isRemember) {
    var _dataAuth$data = dataAuth.data,
        _dataAuth$data$user = _dataAuth$data.user,
        email = _dataAuth$data$user.email,
        empId = _dataAuth$data$user.empId,
        fullName = _dataAuth$data$user.fullName,
        id = _dataAuth$data$user.id,
        token = _dataAuth$data.token,
        expiresDate = _dataAuth$data.expiresDate,
        expiresOn = _dataAuth$data.expiresOn;


    clearToken();
    setCookie(FULL_NAME, fullName);
    setCookie(EMAIL, email);
    setCookie(USER_ID, id);
    setCookie(EMP_ID, empId);
    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    // setCookie(DEVICE_ADMIN, deviceAdmin)
    // setCookie(IS_ADMIN, isAdmin)
}

//getAllCokiesDisplay
function getAllCookiesDisplay() {
    var _ref2;

    return _ref2 = {}, _defineProperty(_ref2, STATION_DISPLAY, getCookie(STATION_DISPLAY)), _defineProperty(_ref2, PICKING_DISPLAY, getCookie(PICKING_DISPLAY)), _defineProperty(_ref2, REPORT_AS_FINISH_DISPLAY, getCookie(REPORT_AS_FINISH_DISPLAY)), _defineProperty(_ref2, JOB_CARD_DISPLAY, getCookie(JOB_CARD_DISPLAY)), _defineProperty(_ref2, WARE_HOUSE_DISPLAY, getCookie(WARE_HOUSE_DISPLAY)), _defineProperty(_ref2, USER_ID, getCookie(USER_ID)), _defineProperty(_ref2, EMP_ID, getCookie(EMP_ID)), _defineProperty(_ref2, FULL_NAME, getCookie(FULL_NAME)), _defineProperty(_ref2, STATION_NAME_DISPLAY, getCookie(STATION_NAME_DISPLAY)), _defineProperty(_ref2, DISPLAY_NAME, getCookie(DISPLAY_NAME)), _defineProperty(_ref2, TABLE_NAME_ACTIVE, getCookie(TABLE_NAME_ACTIVE)), _defineProperty(_ref2, USERNAME, getCookie(USERNAME)), _ref2;
}

//set all cookie display
function setCookieDisplay(data) {
    var stationDisplay = data.stationDisplay,
        pickingDisplay = data.pickingDisplay,
        reportAsFinishDisplay = data.reportAsFinishDisplay,
        jobCardDisplay = data.jobCardDisplay,
        warehouseDisplay = data.warehouseDisplay,
        stationName = data.stationName;

    setCookie(STATION_DISPLAY, stationDisplay);
    setCookie(PICKING_DISPLAY, pickingDisplay);
    setCookie(REPORT_AS_FINISH_DISPLAY, reportAsFinishDisplay);
    setCookie(JOB_CARD_DISPLAY, jobCardDisplay);
    setCookie(WARE_HOUSE_DISPLAY, warehouseDisplay);
    setCookie(STATION_NAME_DISPLAY, stationName);
}

//clear all cookie display
function clearCookieDisplay() {
    removeCookie(STATION_DISPLAY);
    removeCookie(PICKING_DISPLAY);
    removeCookie(REPORT_AS_FINISH_DISPLAY);
    removeCookie(JOB_CARD_DISPLAY);
    removeCookie(WARE_HOUSE_DISPLAY);
    removeCookie(STATION_NAME_DISPLAY);
    removeCookie(USER_ID);
    removeCookie(EMP_ID);
    removeCookie(FULL_NAME);
    removeCookie(DISPLAY_NAME);
    removeCookie(TABLE_NAME_ACTIVE);
}

function setDisplayName(name) {
    console.log(name);
    setCookie(DISPLAY_NAME, name);
}

function getDisplayName() {
    return _defineProperty({}, DISPLAY_NAME, getCookie(DISPLAY_NAME));
}

function setTableNameActive(name) {
    setCookie(TABLE_NAME_ACTIVE, name);
}

function getTableNameActive() {
    return _defineProperty({}, TABLE_NAME_ACTIVE, getCookie(TABLE_NAME_ACTIVE));
}
function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data);
}
function getUrlIncoming() {
    return getCookie(URL_INCOMING);
}

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getErrorList;
/* unused harmony export getCallAPI */
/* harmony export (immutable) */ __webpack_exports__["c"] = getLoading;
/* harmony export (immutable) */ __webpack_exports__["a"] = getContentLoading;
function getErrorList(state) {
    return state.errorList;
}

function getCallAPI(state) {
    return state.callAPI;
}

function getLoading(state) {
    return state.isLoading;
}
function getContentLoading(state) {
    return state.isContentLoading;
}

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(83);



var LoaderExampleInlineCentered = function LoaderExampleInlineCentered() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["p" /* Loader */],
        { active: true, inline: 'centered', size: 'large' },
        'Loading'
    );
};

/* harmony default export */ __webpack_exports__["a"] = (LoaderExampleInlineCentered);

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lib/api.js
// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"
//
// // Localhost
//export const CORE_API_ENDPOINT = "http://localhost:2600"
//export const REDIRECT_O365_URI = 'http://localhost:8080/login';
// export const AX_URL = "http://localhost:8080"

// ProdLine UAT Server
// export const QR_READER_ENDPOINT = "https://imsv2test.cigblusolutions.com"
// export const CORE_API_ENDPOINT = "https://prodlinev2test.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = 'https://prodlinev2test.cigblusolutions.com/login';
var CORE_API_ENDPOINT = "https://prodlinev2.cigblusolutions.com/api";
var REDIRECT_O365_URI = 'https://prodlinev2.cigblusolutions.com/login';
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// ProdLine Prod Server
// export const QR_READER_ENDPOINT = "https://imsv2.cigblusolutions.com"
// export const CORE_API_ENDPOINT = "https://productionline.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://productionline.cigblusolutions.com/login"
// export const AX_URL = "https://cib.operations.dynamics.com"

var CLIENT_ID = '0b1bf20d-a148-44d2-8932-027dbaf66a46';
var ACTIVE_ITEM_TAB = 6; //6
var ACTIVE_ITEM2_TAB = 2; //6
var VERSION_NO = '1.3.0';

var projectName = 'PROD-Line ';
// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(155);

// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/shareFunctions.js
var mapOptions = function mapOptions(data) {
    var options = [];
    options = data.map(function (d) {
        return {
            value: d.id,
            text: d.name
        };
    });
    return options;
};
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return CORE_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return REDIRECT_O365_URI; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CLIENT_ID; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ACTIVE_ITEM_TAB; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ACTIVE_ITEM2_TAB; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return VERSION_NO; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return projectName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return auth["a" /* TOKEN */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return auth["b" /* USER_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["d" /* authenticationDevice */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["c" /* authentication */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["r" /* setO365TokenCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["t" /* setUserImageCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return auth["p" /* getUserImageCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return auth["f" /* clearToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return auth["g" /* getAllCookies */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return auth["n" /* getToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return auth["l" /* getFullName */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return auth["j" /* getDeviceInfoCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return auth["i" /* getDeviceAdmin */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return auth["m" /* getIsAdmin */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["e" /* authenticationEmpMode */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return auth["h" /* getAllCookiesDisplay */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return auth["q" /* setDisplayName */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return auth["k" /* getDisplayName */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["s" /* setTableNameActive */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return auth["o" /* getUrlIncoming */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return mapOptions; });





/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });
        if (resStatusError.includes(res.status)) {
            return reject({ statusCode: res.status, statusText: res.statusText, errorList: state.errorList });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();
            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                var url = { endpoint: endpoint, method: method };
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true, url: url });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            next(action);
        };
    };
});
// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(155);

// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = null;
            var entryType = entry.types[0];

            if (entryType.startsWith('CORE')) {
                token = Object(auth["n" /* getToken */])();
            }

            if (!token) return next(action);
            //  return false
            entry.headers = _extends({}, entry.headers);
            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
            }
            entry.headers['Access-Control-Allow-Origin'] = '*';
            entry.headers['Access-Control-Allow-Methods'] = '*';
            entry.headers['Access-Control-Allow-Headers'] = 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With';

            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"ค้นหา","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"ค้นหา","showLess":"แสดงแบบย่อ","showAll":"แสดงทั้งหมด"}}

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(255);


/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(86);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(260);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 6 modules
var react_router_dom = __webpack_require__(58);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 15 modules
var es = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(277);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(278);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var lib = __webpack_require__(253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/app/components/features/share/loadingInline.js
var loadingInline = __webpack_require__(157);

// CONCATENATED MODULE: ./src/app/components/features/share/loadable/loadableRoute.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var loadableRoute_Loading = function Loading() {
    return react_default.a.createElement(
        'div',
        { className: 'module loadableRoute' },
        react_default.a.createElement(loadingInline["a" /* default */], null)
    );
};

/* harmony default export */ var loadableRoute = (function (opts) {
    return lib_default()(_extends({
        loading: loadableRoute_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 3 modules
var src_lib = __webpack_require__(245);

// CONCATENATED MODULE: ./src/app/routes/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Auth = {
    isAuthenticated: function isAuthenticated() {
        var cookies = Object(src_lib["h" /* getAllCookies */])();
        var isAuth = false;

        if (cookies && cookies[src_lib["d" /* TOKEN */]] && cookies[src_lib["e" /* USER_ID */]]) {
            isAuth = true;
        }
        return isAuth;
    },
    isDevice: function isDevice() {
        var isAdmin = Object(src_lib["j" /* getDeviceAdmin */])();
        return isAdmin.toString() === 'true';
    },
    isAdmin: function isAdmin() {
        var isAdmin = Object(src_lib["n" /* getIsAdmin */])();
        return isAdmin.toString() === 'true';
    }
};

var routePermission_AdminPrivateRoute = function AdminPrivateRoute(_ref) {
    var Component = _ref.component,
        Layout = _ref.layout,
        staticContext = _ref.staticContext,
        rest = _objectWithoutProperties(_ref, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && Auth.isAdmin() === false && props.match.url !== '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_DeviceRoute = function DeviceRoute(_ref2) {
    var Component = _ref2.component,
        Layout = _ref2.layout,
        onGoingJob = _ref2.onGoingJob,
        staticContext = _ref2.staticContext,
        rest = _objectWithoutProperties(_ref2, ['component', 'layout', 'onGoingJob', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && Auth.isDevice() === false && props.match.url !== '/deviceLogin') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                console.log(3);
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/pdOnGoingJob' });
                }
            }
        }
    }));
};

var routePermission_PrivateRoute = function PrivateRoute(_ref3) {
    var Component = _ref3.component,
        Layout = _ref3.layout,
        staticContext = _ref3.staticContext,
        rest = _objectWithoutProperties(_ref3, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_PublicRoute = function PublicRoute(_ref4) {
    var Component = _ref4.component,
        Layout = _ref4.layout,
        onGoingJob = _ref4.onGoingJob,
        staticContext = _ref4.staticContext,
        rest = _objectWithoutProperties(_ref4, ['component', 'layout', 'onGoingJob', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && props.match.url === '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return null;
                }
            }
        }
    }));
};


// CONCATENATED MODULE: ./src/app/routes/Routes.js





//Layout
var LayoutMaster = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 759));
    }
});
var LayoutBlank = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 760));
    }
});

var LayoutBlack = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 761));
    }
});

var LayoutDisplay = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 762));
    }
});
var LayoutPD = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 763));
    }
});

//Features
//Auth
var Login = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 764));
    }
});
var NotFoundController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 765));
    }
});
var UnAuthenController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 766));
    }
});

// Home
var HomeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 767));
    }
});

//Display Table Task
//TableTaskController
var TableTaskController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 768));
    }
});

var SetupTableController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 249));
    }
});

var TableTaskOnJobSetPDController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 769));
    }
});

var TableTaskOnJobSetWorkerController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 770));
    }
});

var TableTaskOnStartController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 771));
    }
});

var ReportAsFinishedController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 250));
    }
    // loader: () => import('../components/features/displayTableTask/reportAsFinish/controllers/reportAsFinishedController')
});

var SetupDisplayNameController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 772));
    }
});
//PD list
var TablePDListAx = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 773));
    }
});
var TablePDList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 774));
    }
});
var TablePDOnGoingList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 775));
    }
});
var CreateDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 776));
    }
});
var UpdateDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 777));
    }
});
var ViewDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 778));
    }
});
var PdLoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 779));
    }
});
var PdDeviceLoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 251));
    }
});
var DrawingDeviceLoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 780));
    }
});
var drawingInfoController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 781));
    }
});
//listDevice
var listDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 782));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        react_router_dom["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PublicRoute, { path: '/reportAsFinished/:id', component: ReportAsFinishedController, layout: LayoutDisplay }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/taskOnStart/:id', component: TableTaskOnStartController, layout: LayoutDisplay }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/taskOnJob/:id', component: TableTaskOnJobSetWorkerController, layout: LayoutDisplay }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/taskOnJob', component: TableTaskOnJobSetPDController, layout: LayoutDisplay }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/setup', component: SetupTableController, layout: LayoutDisplay }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/table', component: TableTaskController, layout: LayoutDisplay }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/admin', component: HomeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/pdList', component: TablePDList, layout: LayoutPD, onGoingJob: false }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/pdListAx', component: TablePDListAx, layout: LayoutPD, onGoingJob: false }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/listDevice', component: listDeviceController, layout: LayoutPD }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/createDevice', component: CreateDeviceController, layout: LayoutPD, onGoingJob: true }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/updateDevice/:id', component: UpdateDeviceController, layout: LayoutPD, onGoingJob: true }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/viewDevice/:id', component: ViewDeviceController, layout: LayoutPD, onGoingJob: true }),
        react_default.a.createElement(routePermission_DeviceRoute, { path: '/drawingInfo', component: drawingInfoController, layout: LayoutPD, onGoingJob: true }),
        react_default.a.createElement(routePermission_DeviceRoute, { path: '/pdOnGoingJob', component: TablePDOnGoingList, layout: LayoutPD, onGoingJob: true }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/drawingLogin', component: DrawingDeviceLoginController, layout: LayoutPD, onGoingJob: true }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/deviceLogin', component: PdDeviceLoginController, layout: LayoutPD, onGoingJob: true }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/', component: PdLoginController, layout: LayoutPD }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/login', component: PdLoginController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/unauthen', component: UnAuthenController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { component: NotFoundController, layout: LayoutMaster })
    );
});
// CONCATENATED MODULE: ./src/app/routes/App.js



/* harmony default export */ var App = (function () {
  return react_default.a.createElement(Routes, null);
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(154);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 269 modules
var dist_es = __webpack_require__(83);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(35);

// CONCATENATED MODULE: ./src/app/redux/actions/actionsCallAPI.js
var actionsCallAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// import { CALL_API } from 'Middlewares'


function actionsCallAPI_setError(errorList, newError, isShow) {
    var mapError = [];
    if (errorList && Array.isArray(errorList)) {
        if (isShow === true) {
            errorList.forEach(function (e) {
                mapError.push(actionsCallAPI__extends({}, e, { isShow: true }));
            });
        } else {
            mapError = mapError.concat(errorList);
        }
    }
    if (newError) {
        mapError.push(actionsCallAPI__extends({}, newError, { isShow: false }));
    }
    console.log(mapError);
    return {
        type: types["_54" /* SET_ERROR */],
        error: mapError
    };
}

function actionsCallAPI_setLoading(isLoading) {
    return {
        type: types["_55" /* SET_LOADING */],
        isLoading: isLoading
    };
}
// EXTERNAL MODULE: ./src/app/redux/selectors/selectorCallAPI.js
var selectorCallAPI = __webpack_require__(156);

// CONCATENATED MODULE: ./src/app/components/features/config.js
var imagePageLogin = '/assets/images/logo-page-login.png';
var image_header = '/assets/images/logo-mene.png';

var iconCloseModalError = '/assets/images/clear.png';
var iconLogoModalError = '/assets/images/icon-deleteCircle-fff.png';
var LogoModalError = '/assets/images/warning.png';
var iconCloseOnBG = '/assets/images/icon-delete-fff.png';

//Image Next Prev
var iconArrowLeft = '/assets/images/icon-arrow-left.png';
var iconArrowRight = '/assets/images/icon-arrow-right.png';
// CONCATENATED MODULE: ./src/app/components/features/share/modal/actionModal.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var actionModal_ActionModal = function (_React$Component) {
    _inherits(ActionModal, _React$Component);

    function ActionModal(props) {
        _classCallCheck(this, ActionModal);

        var _this = _possibleConstructorReturn(this, (ActionModal.__proto__ || Object.getPrototypeOf(ActionModal)).call(this, props));

        _this.state = {
            open: false
        };
        return _this;
    }

    _createClass(ActionModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                type = _props.type,
                header = _props.header,
                detail = _props.detail,
                typeAction = _props.typeAction,
                close = _props.close,
                submit = _props.submit,
                cancelButtonName = _props.cancelButtonName;


            var _type = 'question',
                _header = '',
                _detail = '',
                classModal = '';

            if (type) {
                _type = type;
            }

            _header = header;
            _detail = detail;

            switch (_type) {
                case 'question':
                    classModal = 'question';
                    break;
                case 'warning':
                    classModal = 'warning';
                    break;
                case 'danger':
                    classModal = 'danger';
                    break;
                case 'detail':
                    classModal = 'detail';
                    break;
                default:
                    break;
            }

            return react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(
                    dist_es["q" /* Modal */],
                    { open: open, onClose: close, size: classModal !== 'detail' ? 'tiny' : 'large', className: 'module actionModal' },
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Header,
                        { className: 'headerBG ' + classModal },
                        react_default.a.createElement(
                            dist_es["i" /* Grid */],
                            null,
                            react_default.a.createElement(
                                dist_es["i" /* Grid */].Row,
                                null,
                                react_default.a.createElement(
                                    dist_es["i" /* Grid */].Column,
                                    { width: 16, className: 'inlineFlex' },
                                    react_default.a.createElement(
                                        'div',
                                        { className: 'boxHeaderContent' },
                                        react_default.a.createElement(
                                            'div',
                                            { className: 'boxImageClose', onClick: this.props.close },
                                            react_default.a.createElement('img', { src: iconCloseModalError, alt: '' })
                                        )
                                    ),
                                    classModal !== 'detail' && react_default.a.createElement(
                                        'div',
                                        { className: 'boxImageLogo' },
                                        react_default.a.createElement('img', { src: iconLogoModalError, alt: '', className: 'imgIcon' })
                                    ),
                                    react_default.a.createElement(
                                        'div',
                                        { className: 'boxTextHeader ' + classModal },
                                        react_default.a.createElement(
                                            'p',
                                            { className: 'dialogHeader ' + (classModal !== 'detail' ? ' padLeft20' : '') },
                                            _header
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Content,
                        null,
                        react_default.a.createElement(
                            dist_es["q" /* Modal */].Description,
                            null,
                            react_default.a.createElement(
                                dist_es["i" /* Grid */],
                                null,
                                react_default.a.createElement(
                                    dist_es["i" /* Grid */].Row,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["i" /* Grid */].Column,
                                        { width: 16 },
                                        react_default.a.createElement(
                                            'div',
                                            { className: 'boxTextDetail' },
                                            react_default.a.createElement(
                                                'p',
                                                null,
                                                _detail
                                            ),
                                            react_default.a.createElement('div', { className: 'boxAction' })
                                        )
                                    )
                                ),
                                react_default.a.createElement(
                                    dist_es["i" /* Grid */].Row,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["i" /* Grid */].Column,
                                        { textAlign: 'center' },
                                        react_default.a.createElement(
                                            dist_es["a" /* Button */],
                                            { className: 'btn cancel', onClick: close },
                                            cancelButtonName ? cancelButtonName : 'Cancel'
                                        ),
                                        typeAction === 'delete' && react_default.a.createElement(
                                            dist_es["a" /* Button */],
                                            { className: 'btn delete', onClick: submit },
                                            'Delete'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ActionModal;
}(react_default.a.Component);

/* harmony default export */ var actionModal = (actionModal_ActionModal);
// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(121);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(247);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(246);
var ReactToastify_default = /*#__PURE__*/__webpack_require__.n(ReactToastify);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/errorModal.js
var errorModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function errorModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function errorModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function errorModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import { iconCloseModalError, iconLogoModalError } from '../../config'





var errorModal_ErrorModal = function (_React$Component) {
    errorModal__inherits(ErrorModal, _React$Component);

    function ErrorModal(props) {
        errorModal__classCallCheck(this, ErrorModal);

        var _this = errorModal__possibleConstructorReturn(this, (ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).call(this, props));

        _this.state = {};
        return _this;
    }

    errorModal__createClass(ErrorModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                errorList = _props.errorList,
                t = _props.t;


            return react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(react_toastify_esm["a" /* ToastContainer */], {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    newestOnTop: false,
                    closeOnClick: true,
                    rtl: false,
                    pauseOnFocusLoss: true,
                    draggable: true,
                    pauseOnHover: true
                }),
                errorList.length > 0 && react_toastify_esm["b" /* toast */].error(react_default.a.createElement(
                    react_default.a.Fragment,
                    null,
                    react_default.a.createElement(
                        'p',
                        { style: { fontWeight: 'bold', color: 'white', fontSize: '1em' } },
                        t('common.somethingWrong')
                    ),
                    errorList.map(function (e, i) {
                        var message = e.message,
                            path = e.path,
                            code = e.code;

                        var data = { statusText: message, statusCode: path, code: code };
                        return react_default.a.createElement(errorModal_ItemErrorObj, { key: i, data: data });
                    })
                ), {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    onClose: function onClose() {
                        return _this2.props.setError(null, null, true);
                    }
                })
            );
        }
    }]);

    return ErrorModal;
}(react_default.a.Component);

var errorModal_ItemErrorObj = function ItemErrorObj(props) {
    var data = props.data;


    return react_default.a.createElement(
        dist_es["o" /* List */].Item,
        { className: 'itemError' },
        react_default.a.createElement(
            dist_es["o" /* List */].Content,
            null,
            data.code && react_default.a.createElement(
                'p',
                { style: { color: 'white', fontSize: '0.9em' } },
                data.code
            ),
            react_default.a.createElement(
                'p',
                { style: { color: 'white', fontSize: '0.9em' }, className: 'detailError header' },
                data.statusText
            )
        )
    );
};

/* harmony default export */ var errorModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
    return {
        errorList: Object(selectorCallAPI["b" /* getErrorList */])(state)
    };
}, function (dispatch, _ref) {
    var history = _ref.history;
    return {
        setError: function setError(errorList, newError, isShow) {
            dispatch(actionsCallAPI_setError(errorList, newError, isShow));
        }
    };
}), Object(Recompose["b" /* lifecycle */])({}))(errorModal_ErrorModal));
// CONCATENATED MODULE: ./src/app/components/features/share/loading.js




var loading_Loading = function Loading(props) {
    var active = props && props.isActive ? props.isActive : false;

    return react_default.a.createElement(
        dist_es["e" /* Dimmer */],
        { style: { position: 'fixed' }, active: active },
        react_default.a.createElement(loadingInline["a" /* default */], null)
    );
};

/* harmony default export */ var share_loading = (loading_Loading);
// CONCATENATED MODULE: ./src/app/components/features/share/modal/loadingModal.js
var loadingModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function loadingModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loadingModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function loadingModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var loadingModal_LoadingModal = function (_React$Component) {
    loadingModal__inherits(LoadingModal, _React$Component);

    function LoadingModal(props) {
        loadingModal__classCallCheck(this, LoadingModal);

        var _this = loadingModal__possibleConstructorReturn(this, (LoadingModal.__proto__ || Object.getPrototypeOf(LoadingModal)).call(this, props));

        _this.state = {
            isLoading: false
        };
        return _this;
    }

    loadingModal__createClass(LoadingModal, [{
        key: 'render',
        value: function render() {
            var loading = this.props.loading;


            return react_default.a.createElement(share_loading, { isActive: loading });
        }
    }]);

    return LoadingModal;
}(react_default.a.Component);

/* harmony default export */ var loadingModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
    return {
        loading: Object(selectorCallAPI["c" /* getLoading */])(state)
    };
}, function (dispatch, _ref) {
    var history = _ref.history;
    return {
        setLoading: function setLoading(isLoading) {
            dispatch(actionsCallAPI_setLoading(isLoading));
        }
    };
}), Object(Recompose["b" /* lifecycle */])({}))(loadingModal_LoadingModal));
// EXTERNAL MODULE: ./src/app/components/scss/index.scss
var scss = __webpack_require__(531);
var scss_default = /*#__PURE__*/__webpack_require__.n(scss);

// CONCATENATED MODULE: ./src/app/routes/Root.js






// import ErrorBoundary from '../components/features/share/ErrorBoundary'

// import Loading from '../components/features/share/loading'


var store = configureStore_default()();

/* harmony default export */ var Root = (function () {
    return react_default.a.createElement(
        es["a" /* Provider */],
        { store: store },
        react_default.a.createElement(
            react_router_dom["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(App, null),
                react_default.a.createElement(errorModal, null),
                react_default.a.createElement(loadingModal, null)
            )
        )
    );
});
// EXTERNAL MODULE: ./src/wording/language/en/common.json
var common = __webpack_require__(539);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/wording/language/en/login.json
var login = __webpack_require__(540);
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./src/wording/language/en/search.json
var search = __webpack_require__(541);
var search_default = /*#__PURE__*/__webpack_require__.n(search);

// EXTERNAL MODULE: ./src/wording/language/en/header.json
var en_header = __webpack_require__(542);
var header_default = /*#__PURE__*/__webpack_require__.n(en_header);

// EXTERNAL MODULE: ./src/wording/language/en/button.json
var en_button = __webpack_require__(543);
var button_default = /*#__PURE__*/__webpack_require__.n(en_button);

// EXTERNAL MODULE: ./src/wording/language/en/home.json
var home = __webpack_require__(544);
var home_default = /*#__PURE__*/__webpack_require__.n(home);

// EXTERNAL MODULE: ./src/wording/language/en/menu.json
var menu = __webpack_require__(545);
var menu_default = /*#__PURE__*/__webpack_require__.n(menu);

// EXTERNAL MODULE: ./src/wording/language/en/share.json
var share = __webpack_require__(546);
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: ./src/wording/language/en/user.json
var user = __webpack_require__(547);
var user_default = /*#__PURE__*/__webpack_require__.n(user);

// EXTERNAL MODULE: ./src/wording/language/en/master.json
var master = __webpack_require__(548);
var master_default = /*#__PURE__*/__webpack_require__.n(master);

// EXTERNAL MODULE: ./src/wording/language/en/warehouse.json
var warehouse = __webpack_require__(549);
var warehouse_default = /*#__PURE__*/__webpack_require__.n(warehouse);

// EXTERNAL MODULE: ./src/wording/language/en/display.json
var display = __webpack_require__(550);
var display_default = /*#__PURE__*/__webpack_require__.n(display);

// EXTERNAL MODULE: ./src/wording/language/en/pd.json
var pd = __webpack_require__(551);
var pd_default = /*#__PURE__*/__webpack_require__.n(pd);

// CONCATENATED MODULE: ./src/wording/language/en.js
var en__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















/* harmony default export */ var en = (en__extends({}, common_default.a, login_default.a, search_default.a, header_default.a, button_default.a, home_default.a, menu_default.a, share_default.a, user_default.a, master_default.a, warehouse_default.a, display_default.a, pd_default.a));
// EXTERNAL MODULE: ./src/wording/language/th/common.json
var th_common = __webpack_require__(552);
var th_common_default = /*#__PURE__*/__webpack_require__.n(th_common);

// EXTERNAL MODULE: ./src/wording/language/th/login.json
var th_login = __webpack_require__(553);
var th_login_default = /*#__PURE__*/__webpack_require__.n(th_login);

// EXTERNAL MODULE: ./src/wording/language/th/search.json
var th_search = __webpack_require__(252);
var th_search_default = /*#__PURE__*/__webpack_require__.n(th_search);

// EXTERNAL MODULE: ./src/wording/language/th/button.json
var th_button = __webpack_require__(554);
var th_button_default = /*#__PURE__*/__webpack_require__.n(th_button);

// EXTERNAL MODULE: ./src/wording/language/th/home.json
var th_home = __webpack_require__(555);
var th_home_default = /*#__PURE__*/__webpack_require__.n(th_home);

// EXTERNAL MODULE: ./src/wording/language/th/menu.json
var th_menu = __webpack_require__(556);
var th_menu_default = /*#__PURE__*/__webpack_require__.n(th_menu);

// EXTERNAL MODULE: ./src/wording/language/th/share.json
var th_share = __webpack_require__(557);
var th_share_default = /*#__PURE__*/__webpack_require__.n(th_share);

// EXTERNAL MODULE: ./src/wording/language/th/user.json
var th_user = __webpack_require__(558);
var th_user_default = /*#__PURE__*/__webpack_require__.n(th_user);

// EXTERNAL MODULE: ./src/wording/language/th/master.json
var th_master = __webpack_require__(559);
var th_master_default = /*#__PURE__*/__webpack_require__.n(th_master);

// EXTERNAL MODULE: ./src/wording/language/th/warehouse.json
var th_warehouse = __webpack_require__(560);
var th_warehouse_default = /*#__PURE__*/__webpack_require__.n(th_warehouse);

// EXTERNAL MODULE: ./src/wording/language/th/display.json
var th_display = __webpack_require__(561);
var th_display_default = /*#__PURE__*/__webpack_require__.n(th_display);

// EXTERNAL MODULE: ./src/wording/language/th/pd.json
var th_pd = __webpack_require__(562);
var th_pd_default = /*#__PURE__*/__webpack_require__.n(th_pd);

// CONCATENATED MODULE: ./src/wording/language/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















/* harmony default export */ var th = (th__extends({}, th_common_default.a, th_login_default.a, th_search_default.a, th_search_default.a, th_button_default.a, th_home_default.a, th_menu_default.a, th_share_default.a, th_user_default.a, th_master_default.a, th_warehouse_default.a, th_display_default.a, th_pd_default.a));
// CONCATENATED MODULE: ./src/index.js










Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('en');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root);

if (false) {
    module.hot.accept('./app/routes/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(279);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(60);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(280);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(248);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 229 modules
var redux_form_es = __webpack_require__(283);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerAuth.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var reducerAuth_initialState = {
    user: null
};

/* harmony default export */ var reducerAuth = ({
    authen: function authen() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerAuth_initialState;
        var action = arguments[1];

        switch (action.type) {
            default:
                return _extends({}, state);
        }
    }
});
// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(35);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerCallAPI.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var initialStateCallAPI = {
    isLoading: false,

    hasError: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
},
    initialStateArray = [];

/* harmony default export */ var reducerCallAPI = ({
    errorList: function errorList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateArray;
        var action = arguments[1];

        switch (action.type) {
            case types["_54" /* SET_ERROR */]:
                var newError = [];
                if (action && Array.isArray(action.error)) {
                    newError = action.error;
                }
                return newError;

            case types["l" /* CORE_AUTH_VERIFY_SUCCESS */]:
            case types["_19" /* CORE_MANAGER_VERIFY_SUCCESS */]:
            case types["o" /* CORE_CREATE_DEVICE_SUCCESS */]:
            case types["_46" /* CORE_UPDATE_DEVICE_SUCCESS */]:
            case types["j" /* CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS */]:
            case types["S" /* CORE_GET_DRAWING_INFO_SUCCESS */]:
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload = action.payload,
                        errors = _action$payload.errors,
                        result = _action$payload.result;
                    var url = action.url;

                    var _newError = [];
                    if (!result) {
                        if (Array.isArray(errors)) {
                            errors.map(function (e) {
                                var path = e.path,
                                    code = e.code,
                                    message = e.message;

                                return _newError.push({ code: code, message: message, isShow: true, path: path, url: url, isFromAction: true });
                            });
                        } else _newError.push({ code: 'unknow', message: 'Some thing went wrong', isShow: true, path: '', url: url, isFromAction: true });
                    }

                    return _newError;
                }
                return state;

            case types["g" /* CORE_AUTH_VERIFY_FAILURE */]:
            case types["_17" /* CORE_MANAGER_VERIFY_FAILURE */]:
            case types["m" /* CORE_CREATE_DEVICE_FAILURE */]:
            case types["_44" /* CORE_UPDATE_DEVICE_FAILURE */]:
            case types["h" /* CORE_AUTH_VERIFY_PD_DEVICE_FAILURE */]:
            case types["Q" /* CORE_GET_DRAWING_INFO_FAILURE */]:
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        code = _action$payload2.code,
                        message = _action$payload2.message,
                        statusText = _action$payload2.statusText,
                        statusCode = _action$payload2.statusCode;
                    var _url = action.url;

                    var _newError2 = [];

                    _newError2.push({
                        code: code ? code : '404',
                        message: message,
                        isShow: false,
                        statusText: statusText,
                        statusCode: statusCode,
                        url: _url
                    });

                    return _newError2;
                }
                return state;
            default:
                return state;
        }
    },
    isLoading: function isLoading() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            // case CORE_GET_TRANSFER_BY_ID_REQUEST:
            case types["w" /* CORE_GET_ALL_DEVICE_REQUEST */]:
            case types["O" /* CORE_GET_DEVICE_REQUEST */]:
            case types["_36" /* CORE_SET_WORKER_REQUEST */]:
            case types["_33" /* CORE_SET_START_TIME_REQUEST */]:
            case types["_30" /* CORE_SET_END_TIME_REQUEST */]:
            case types["_42" /* CORE_TASK_ON_JOB_REQUEST */]:
            case types["_24" /* CORE_REPORT_AS_FINISHED_DATAS_REQUEST */]:
            case types["_9" /* CORE_LOAD_RESOURCES_REQUEST */]:
            case types["_15" /* CORE_LOAD_WAREHOUSES_REQUEST */]:
            case types["_12" /* CORE_LOAD_SCRAPS_REQUEST */]:
            case types["_6" /* CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST */]:
            case types["M" /* CORE_GET_DEVICE_INFO_REQUEST */]:
                // case CORE_GET_ALL_PD_LIST_REQUEST:
                return true;
            // case CORE_GET_TRANSFER_BY_ID_SUCCESS:
            case types["x" /* CORE_GET_ALL_DEVICE_SUCCESS */]:
            case types["P" /* CORE_GET_DEVICE_SUCCESS */]:
            case types["_37" /* CORE_SET_WORKER_SUCCESS */]:
            case types["_34" /* CORE_SET_START_TIME_SUCCESS */]:
            case types["_31" /* CORE_SET_END_TIME_SUCCESS */]:
            case types["_43" /* CORE_TASK_ON_JOB_SUCCESS */]:
            case types["_25" /* CORE_REPORT_AS_FINISHED_DATAS_SUCCESS */]:
            case types["_10" /* CORE_LOAD_RESOURCES_SUCCESS */]:
            case types["_16" /* CORE_LOAD_WAREHOUSES_SUCCESS */]:
            case types["_13" /* CORE_LOAD_SCRAPS_SUCCESS */]:
            case types["_7" /* CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS */]:
            case types["N" /* CORE_GET_DEVICE_INFO_SUCCESS */]:
                // case CORE_GET_ALL_PD_LIST_SUCCESS:
                return false;
            // case CORE_GET_TRANSFER_BY_ID_FAILURE:
            case types["v" /* CORE_GET_ALL_DEVICE_FAILURE */]:
            case types["K" /* CORE_GET_DEVICE_FAILURE */]:
            case types["_35" /* CORE_SET_WORKER_FAILURE */]:
            case types["_32" /* CORE_SET_START_TIME_FAILURE */]:
            case types["_29" /* CORE_SET_END_TIME_FAILURE */]:
            case types["_41" /* CORE_TASK_ON_JOB_FAILURE */]:
            case types["_23" /* CORE_REPORT_AS_FINISHED_DATAS_FAILURE */]:
            case types["_8" /* CORE_LOAD_RESOURCES_FAILURE */]:
            case types["_14" /* CORE_LOAD_WAREHOUSES_FAILURE */]:
            case types["_11" /* CORE_LOAD_SCRAPS_FAILURE */]:
            case types["_5" /* CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE */]:
            case types["L" /* CORE_GET_DEVICE_INFO_FAILURE */]:
                // case CORE_GET_ALL_PD_LIST_FAILURE:
                return false;
            default:
                return state;
        }
    },
    isContentLoading: function isContentLoading() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        // return false;
        switch (action.type) {
            case types["C" /* CORE_GET_ALL_PD_LIST_REQUEST */]:
                return true;
            case types["D" /* CORE_GET_ALL_PD_LIST_SUCCESS */]:
                return false;
            case types["B" /* CORE_GET_ALL_PD_LIST_FAILURE */]:
                return false;
            default:
                return state;
        }
    },
    reducerCallAPI: function reducerCallAPI() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateCallAPI;
        var action = arguments[1];

        switch (action.type) {
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/user.js
var user__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var requestState = types["_53" /* REQUEST_STATE */];

/* harmony default export */ var reducers_user = ({
    user: function user() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_3" /* CORE_GET_USER_INFO_REQUEST */]:
                return state;
            case types["_4" /* CORE_GET_USER_INFO_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && user__typeof(action.payload) === 'object') {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_2" /* CORE_GET_USER_INFO_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    users: function users() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_0" /* CORE_GET_USERS_REQUEST */]:
                return state;
            case types["_1" /* CORE_GET_USERS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["Z" /* CORE_GET_USERS_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/axData.js



var axData_requestState = types["_53" /* REQUEST_STATE */];

/* harmony default export */ var axData = ({
    resources: function resources() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_9" /* CORE_LOAD_RESOURCES_REQUEST */]:
                return state;
            case types["_10" /* CORE_LOAD_RESOURCES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_8" /* CORE_LOAD_RESOURCES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    warehouses: function warehouses() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_15" /* CORE_LOAD_WAREHOUSES_REQUEST */]:
                return state;
            case types["_16" /* CORE_LOAD_WAREHOUSES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_14" /* CORE_LOAD_WAREHOUSES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    scraps: function scraps() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_12" /* CORE_LOAD_SCRAPS_REQUEST */]:
                return state;
            case types["_13" /* CORE_LOAD_SCRAPS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        datas = _action$payload3.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_11" /* CORE_LOAD_SCRAPS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    materials: function materials() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_6" /* CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST */]:
                return state;
            case types["_7" /* CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_5" /* CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE */]:
                return [];
            default:
                return state;
        }
    }

    // masterStation: (state = requestState, action) => {
    //     switch (action.type) {
    //         case CORE_LOAD_MASTER_DATA_STATION_REQUEST:
    //             return state
    //         case CORE_LOAD_MASTER_DATA_STATION_SUCCESS:
    //             if (action.payload) {
    //                 const { result, data } = action.payload
    //                 if (result && data) {
    //                     return data
    //                 } else return {}
    //             } else {
    //                 return {}
    //             }
    //         case CORE_LOAD_MASTER_DATA_STATION_FAILURE:
    //             return {}
    //         default:
    //             return state
    //     }
    // },
});
// CONCATENATED MODULE: ./src/app/redux/reducers/display.js
var display__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var display_requestState = types["_53" /* REQUEST_STATE */];

/* harmony default export */ var display = ({
    getTables: function getTables() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["F" /* CORE_GET_ALL_TABLE_REQUEST */]:
                return state;
            case types["G" /* CORE_GET_ALL_TABLE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["E" /* CORE_GET_ALL_TABLE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    getTable: function getTable() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["X" /* CORE_GET_TABLE_BY_ID_REQUEST */]:
                return state;
            case types["Y" /* CORE_GET_TABLE_BY_ID_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["W" /* CORE_GET_TABLE_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    pdsmAxData: function pdsmAxData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_42" /* CORE_TASK_ON_JOB_REQUEST */]:
                return state;
            case types["_43" /* CORE_TASK_ON_JOB_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    console.log(action.payload);
                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_41" /* CORE_TASK_ON_JOB_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    setStartTime: function setStartTime() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_33" /* CORE_SET_START_TIME_REQUEST */]:
                return state;
            case types["_34" /* CORE_SET_START_TIME_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        data = _action$payload4.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_32" /* CORE_SET_START_TIME_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    setEndTime: function setEndTime() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_30" /* CORE_SET_END_TIME_REQUEST */]:
                return state;
            case types["_31" /* CORE_SET_END_TIME_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        data = _action$payload5.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_29" /* CORE_SET_END_TIME_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    setWorker: function setWorker() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_36" /* CORE_SET_WORKER_REQUEST */]:
                return state;
            case types["_37" /* CORE_SET_WORKER_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload6 = action.payload,
                        result = _action$payload6.result,
                        data = _action$payload6.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_35" /* CORE_SET_WORKER_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    reportFinishData: function reportFinishData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_24" /* CORE_REPORT_AS_FINISHED_DATAS_REQUEST */]:
                return state;
            case types["_25" /* CORE_REPORT_AS_FINISHED_DATAS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload7 = action.payload,
                        result = _action$payload7.result,
                        datas = _action$payload7.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_23" /* CORE_REPORT_AS_FINISHED_DATAS_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/pdList.js


var pdList_requestState = types["_53" /* REQUEST_STATE */];

/* harmony default export */ var pdList = ({
    getAllPdLists: function getAllPdLists() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pdList_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["C" /* CORE_GET_ALL_PD_LIST_REQUEST */]:
                return state;
            case types["D" /* CORE_GET_ALL_PD_LIST_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["B" /* CORE_GET_ALL_PD_LIST_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    getAllPdAxLists: function getAllPdAxLists() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pdList_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["z" /* CORE_GET_ALL_PD_AX_LIST_REQUEST */]:
                return state;
            case types["A" /* CORE_GET_ALL_PD_AX_LIST_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["y" /* CORE_GET_ALL_PD_AX_LIST_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    getPrintDetail: function getPrintDetail() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pdList_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_21" /* CORE_POST_PRINT_REQUEST */]:
                return state;
            case types["_22" /* CORE_POST_PRINT_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    }
                    return [];
                } else return [];
            case types["_20" /* CORE_POST_PRINT_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/device.js
var device__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var device_requestState = types["_53" /* REQUEST_STATE */];

/* harmony default export */ var reducers_device = ({
    allDevice: function allDevice() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : device_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["w" /* CORE_GET_ALL_DEVICE_REQUEST */]:
                return state;
            case types["x" /* CORE_GET_ALL_DEVICE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["v" /* CORE_GET_ALL_DEVICE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    device: function device() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : device_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["O" /* CORE_GET_DEVICE_REQUEST */]:
            case types["n" /* CORE_CREATE_DEVICE_REQUEST */]:
            case types["_45" /* CORE_UPDATE_DEVICE_REQUEST */]:
            case types["i" /* CORE_AUTH_VERIFY_PD_DEVICE_REQUEST */]:
                return state;
            case types["P" /* CORE_GET_DEVICE_SUCCESS */]:
            case types["o" /* CORE_CREATE_DEVICE_SUCCESS */]:
            case types["_46" /* CORE_UPDATE_DEVICE_SUCCESS */]:
            case types["j" /* CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && device__typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["K" /* CORE_GET_DEVICE_FAILURE */]:
            case types["m" /* CORE_CREATE_DEVICE_FAILURE */]:
            case types["_44" /* CORE_UPDATE_DEVICE_FAILURE */]:
            case types["h" /* CORE_AUTH_VERIFY_PD_DEVICE_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    deviceInfo: function deviceInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : device_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["M" /* CORE_GET_DEVICE_INFO_REQUEST */]:
                return state;
            case types["N" /* CORE_GET_DEVICE_INFO_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && device__typeof(action.payload) === 'object') {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["L" /* CORE_GET_DEVICE_INFO_FAILURE */]:
                return {};
            default:
                return state;
        }
    },

    taskListDetail: function taskListDetail() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : device_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["I" /* CORE_GET_DETAIL_TASKLIST_REQUEST */]:
                return state;
            case types["J" /* CORE_GET_DETAIL_TASKLIST_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && device__typeof(action.payload) === 'object') {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        data = _action$payload4.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["H" /* CORE_GET_DETAIL_TASKLIST_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers.js


// import { reducer as notificationsReducer } from 'reapop'









/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: reducers_user.users,
    user: reducers_user.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,
    isContentLoading: reducerCallAPI.isContentLoading,

    resources: axData.resources,
    warehouses: axData.warehouses,
    scraps: axData.scraps,

    materials: axData.materials,

    tablesData: display.getTables,
    tableData: display.getTable,
    pdsmAxData: display.pdsmAxData,
    startTimeData: display.setStartTime,
    endTimeData: display.setEndTime,
    workerData: display.setWorker,
    reportFinishData: display.reportFinishData,
    getAllPdLists: pdList.getAllPdLists,
    getAllPdAxLists: pdList.getAllPdAxLists,
    pdPrintDetail: pdList.getPrintDetail,

    allDevice: reducers_device.allDevice,
    device: reducers_device.device,
    deviceInfo: reducers_device.deviceInfo,
    taskListDetail: reducers_device.taskListDetail
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return REQUEST_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return SET_LOADING; });
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_GET_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_GET_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_GET_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_GET_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_GET_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_GET_USER_INFO_FAILURE; });
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_REQUEST */
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_SUCCESS */
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_FAILURE */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_AUTH_VERIFY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_AUTH_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_AUTH_VERIFY_FAILURE; });
/* unused harmony export CORE_GET_REQUEST_INFO_REQUEST */
/* unused harmony export CORE_GET_REQUEST_INFO_SUCCESS */
/* unused harmony export CORE_GET_REQUEST_INFO_FAILURE */
/* unused harmony export CORE_GET_RM_TAG_REQUEST */
/* unused harmony export CORE_GET_RM_TAG_SUCCESS */
/* unused harmony export CORE_GET_RM_TAG_FAILURE */
/* unused harmony export CORE_CREATE_RM_TAG_REQUEST */
/* unused harmony export CORE_CREATE_RM_TAG_SUCCESS */
/* unused harmony export CORE_CREATE_RM_TAG_FAILURE */
/* unused harmony export CORE_GET_PD_TAG_REQUEST */
/* unused harmony export CORE_GET_PD_TAG_SUCCESS */
/* unused harmony export CORE_GET_PD_TAG_FAILURE */
/* unused harmony export CORE_CREATE_PD_TAG_REQUEST */
/* unused harmony export CORE_CREATE_PD_TAG_SUCCESS */
/* unused harmony export CORE_CREATE_PD_TAG_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_LOAD_RESOURCES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_LOAD_RESOURCES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_LOAD_RESOURCES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_LOAD_WAREHOUSES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_LOAD_WAREHOUSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_LOAD_WAREHOUSES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_LOAD_SCRAPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_LOAD_SCRAPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_LOAD_SCRAPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CREATE_REGISTER_DAPLAYS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CREATE_REGISTER_DAPLAYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CREATE_REGISTER_DAPLAYS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_ACTIVE_DISPLAYS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_ACTIVE_DISPLAYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_ACTIVE_DISPLAYS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_GET_ALL_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_GET_ALL_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_GET_ALL_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_GET_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_GET_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_GET_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_MANAGER_VERIFY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_MANAGER_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_MANAGER_VERIFY_FAILURE; });
/* unused harmony export CORE_GET_PDS_FROM_AX_REQUEST */
/* unused harmony export CORE_GET_PDS_FROM_AX_SUCCESS */
/* unused harmony export CORE_GET_PDS_FROM_AX_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_SET_WORKER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_SET_WORKER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_SET_WORKER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_SET_START_TIME_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_SET_START_TIME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_SET_START_TIME_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_SET_END_TIME_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_SET_END_TIME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_SET_END_TIME_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_TASK_ON_JOB_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_TASK_ON_JOB_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_TASK_ON_JOB_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_REPORT_AS_FINISHED_DATAS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_REPORT_AS_FINISHED_DATAS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_REPORT_AS_FINISHED_DATAS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_AUTH_VERIFY_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_AUTH_VERIFY_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_AUTH_VERIFY_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_GET_ALL_PD_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_GET_ALL_PD_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_GET_ALL_PD_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_POST_PRINT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_POST_PRINT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_POST_PRINT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_GET_ALL_TABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_GET_ALL_TABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_GET_ALL_TABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_GET_TABLE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_GET_TABLE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_GET_TABLE_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_AUTH_VERIFY_PD_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_AUTH_VERIFY_PD_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_GET_DEVICE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_GET_DEVICE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_GET_DEVICE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_USER_CHECKIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_USER_CHECKIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_USER_CHECKIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_USER_CHECKOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_USER_CHECKOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_USER_CHECKOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_GET_DETAIL_TASKLIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_GET_DETAIL_TASKLIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_GET_DETAIL_TASKLIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_START_JOB_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_START_JOB_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_START_JOB_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_END_JOB_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_END_JOB_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_END_JOB_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CREATE_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CREATE_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CREATE_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_UPDATE_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_UPDATE_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_UPDATE_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_GET_ALL_PD_AX_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_GET_ALL_PD_AX_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_GET_ALL_PD_AX_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_SEND_PD_TO_AX_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_SEND_PD_TO_AX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_SEND_PD_TO_AX_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_GET_DRAWING_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_GET_DRAWING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_GET_DRAWING_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_GET_RF_PD_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_GET_RF_PD_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_GET_RF_PD_LIST_FAILURE; });
var REQUEST_STATE = 'REQUEST_STATE';
var SET_ERROR = 'SET_ERROR';
var SET_LOADING = 'SET_LOADING';

var LOGOUT = 'LOGOUT';
var CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST';
var CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS';
var CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE';

var CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST';
var CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS';
var CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE';

var CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST';
var CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS';
var CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE';

var CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST';
var CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS';
var CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE';

//AUTH
var CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
var CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
var CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

var CORE_GET_REQUEST_INFO_REQUEST = 'CORE_GET_REQUEST_INFO_REQUEST';
var CORE_GET_REQUEST_INFO_SUCCESS = 'CORE_GET_REQUEST_INFO_SUCCESS';
var CORE_GET_REQUEST_INFO_FAILURE = 'CORE_GET_REQUEST_INFO_FAILURE';

//QR Tag
var CORE_GET_RM_TAG_REQUEST = 'CORE_GET_RM_TAG_REQUEST';
var CORE_GET_RM_TAG_SUCCESS = 'CORE_GET_RM_TAG_SUCCESS';
var CORE_GET_RM_TAG_FAILURE = 'CORE_GET_RM_TAG_FAILURE';

var CORE_CREATE_RM_TAG_REQUEST = 'CORE_CREATE_RM_TAG_REQUEST';
var CORE_CREATE_RM_TAG_SUCCESS = 'CORE_CREATE_RM_TAG_SUCCESS';
var CORE_CREATE_RM_TAG_FAILURE = 'CORE_CREATE_RM_TAG_FAILURE';

var CORE_GET_PD_TAG_REQUEST = 'CORE_GET_PD_TAG_REQUEST';
var CORE_GET_PD_TAG_SUCCESS = 'CORE_GET_PD_TAG_SUCCESS';
var CORE_GET_PD_TAG_FAILURE = 'CORE_GET_PD_TAG_FAILURE';

var CORE_CREATE_PD_TAG_REQUEST = 'CORE_CREATE_PD_TAG_REQUEST';
var CORE_CREATE_PD_TAG_SUCCESS = 'CORE_CREATE_PD_TAG_SUCCESS';
var CORE_CREATE_PD_TAG_FAILURE = 'CORE_CREATE_PD_TAG_FAILURE';

//GET RESOURCES
var CORE_LOAD_RESOURCES_REQUEST = 'CORE_LOAD_RESOURCES_REQUEST';
var CORE_LOAD_RESOURCES_SUCCESS = 'CORE_LOAD_RESOURCES_SUCCESS';
var CORE_LOAD_RESOURCES_FAILURE = 'CORE_LOAD_RESOURCES_FAILURE';

//GET WAREHOUSES
var CORE_LOAD_WAREHOUSES_REQUEST = 'CORE_LOAD_WAREHOUSES_REQUEST';
var CORE_LOAD_WAREHOUSES_SUCCESS = 'CORE_LOAD_WAREHOUSES_SUCCESS';
var CORE_LOAD_WAREHOUSES_FAILURE = 'CORE_LOAD_WAREHOUSES_FAILURE';

//GET SCRAPT

var CORE_LOAD_SCRAPS_REQUEST = 'CORE_LOAD_SCRAPS_REQUEST';
var CORE_LOAD_SCRAPS_SUCCESS = 'CORE_LOAD_SCRAPS_SUCCESS';
var CORE_LOAD_SCRAPS_FAILURE = 'CORE_LOAD_SCRAPS_FAILURE';

var CORE_CREATE_REGISTER_DAPLAYS_REQUEST = 'CORE_CREATE_REGISTER_DAPLAYS_REQUEST';
var CORE_CREATE_REGISTER_DAPLAYS_SUCCESS = 'CORE_CREATE_REGISTER_DAPLAYS_SUCCESS';
var CORE_CREATE_REGISTER_DAPLAYS_FAILURE = 'CORE_CREATE_REGISTER_DAPLAYS_FAILURE';

var CORE_ACTIVE_DISPLAYS_REQUEST = 'CORE_ACTIVE_DISPLAYS_REQUEST';
var CORE_ACTIVE_DISPLAYS_SUCCESS = 'CORE_ACTIVE_DISPLAYS_SUCCESS';
var CORE_ACTIVE_DISPLAYS_FAILURE = 'CORE_ACTIVE_DISPLAYS_FAILURE';

var CORE_GET_ALL_DEVICE_REQUEST = 'CORE_GET_ALL_DEVICE_REQUEST';
var CORE_GET_ALL_DEVICE_SUCCESS = 'CORE_GET_ALL_DEVICE_SUCCESS';
var CORE_GET_ALL_DEVICE_FAILURE = 'CORE_GET_ALL_DEVICE_FAILURE';

var CORE_GET_DEVICE_REQUEST = 'CORE_GET_DEVICE_REQUEST';
var CORE_GET_DEVICE_SUCCESS = 'CORE_GET_DEVICE_SUCCESS';
var CORE_GET_DEVICE_FAILURE = 'CORE_GET_DEVICE_FAILURE';

var CORE_MANAGER_VERIFY_REQUEST = 'CORE_MANAGER_VERIFY_REQUEST';
var CORE_MANAGER_VERIFY_SUCCESS = 'CORE_MANAGER_VERIFY_SUCCESS';
var CORE_MANAGER_VERIFY_FAILURE = 'CORE_MANAGER_VERIFY_FAILURE';

var CORE_GET_PDS_FROM_AX_REQUEST = 'CORE_GET_PDS_FROM_AX_REQUEST';
var CORE_GET_PDS_FROM_AX_SUCCESS = 'CORE_GET_PDS_FROM_AX_SUCCESS';
var CORE_GET_PDS_FROM_AX_FAILURE = 'CORE_GET_PDS_FROM_AX_FAILURE';

var CORE_SET_WORKER_REQUEST = 'CORE_SET_WORKER_REQUEST';
var CORE_SET_WORKER_SUCCESS = 'CORE_SET_WORKER_SUCCESS';
var CORE_SET_WORKER_FAILURE = 'CORE_SET_WORKER_FAILURE';

var CORE_SET_START_TIME_REQUEST = 'CORE_SET_START_TIME_REQUEST';
var CORE_SET_START_TIME_SUCCESS = 'CORE_SET_START_TIME_SUCCESS';
var CORE_SET_START_TIME_FAILURE = 'CORE_SET_START_TIME_FAILURE';

var CORE_SET_END_TIME_REQUEST = 'CORE_SET_END_TIME_REQUEST';
var CORE_SET_END_TIME_SUCCESS = 'CORE_SET_END_TIME_SUCCESS';
var CORE_SET_END_TIME_FAILURE = 'CORE_SET_END_TIME_FAILURE';

var CORE_TASK_ON_JOB_REQUEST = 'CORE_TASK_ON_JOB_REQUEST';
var CORE_TASK_ON_JOB_SUCCESS = 'CORE_TASK_ON_JOB_SUCCESS';
var CORE_TASK_ON_JOB_FAILURE = 'CORE_TASK_ON_JOB_FAILURE';

var CORE_REPORT_AS_FINISHED_DATAS_REQUEST = 'CORE_REPORT_AS_FINISHED_DATAS_REQUEST';
var CORE_REPORT_AS_FINISHED_DATAS_SUCCESS = 'CORE_REPORT_AS_FINISHED_DATAS_SUCCESS';
var CORE_REPORT_AS_FINISHED_DATAS_FAILURE = 'CORE_REPORT_AS_FINISHED_DATAS_FAILURE';

var CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST = 'CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST';
var CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS = 'CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS';
var CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE = 'CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE';

var CORE_AUTH_VERIFY_DEVICE_REQUEST = 'CORE_AUTH_VERIFY_DEVICE_REQUEST';
var CORE_AUTH_VERIFY_DEVICE_SUCCESS = 'CORE_AUTH_VERIFY_DEVICE_SUCCESS';
var CORE_AUTH_VERIFY_DEVICE_FAILURE = 'CORE_AUTH_VERIFY_DEVICE_FAILURE';

var CORE_GET_ALL_PD_LIST_REQUEST = 'CORE_GET_ALL_PD_LIST_REQUEST';
var CORE_GET_ALL_PD_LIST_SUCCESS = 'CORE_GET_ALL_PD_LIST_SUCCESS';
var CORE_GET_ALL_PD_LIST_FAILURE = 'CORE_GET_ALL_PD_LIST_FAILURE';

var CORE_POST_PRINT_REQUEST = 'CORE_POST_PRINT_REQUEST';
var CORE_POST_PRINT_SUCCESS = 'CORE_POST_PRINT_SUCCESS';
var CORE_POST_PRINT_FAILURE = 'CORE_POST_PRINT_FAILURE';

var CORE_GET_ALL_TABLE_REQUEST = 'CORE_GET_ALL_TABLE_REQUEST';
var CORE_GET_ALL_TABLE_SUCCESS = 'CORE_GET_ALL_TABLE_SUCCESS';
var CORE_GET_ALL_TABLE_FAILURE = 'CORE_GET_ALL_TABLE_FAILURE';

var CORE_GET_TABLE_BY_ID_REQUEST = 'CORE_GET_TABLE_BY_ID_REQUEST';
var CORE_GET_TABLE_BY_ID_SUCCESS = 'CORE_GET_TABLE_BY_ID_SUCCESS';
var CORE_GET_TABLE_BY_ID_FAILURE = 'CORE_GET_TABLE_BY_ID_FAILURE';

var CORE_AUTH_VERIFY_PD_DEVICE_REQUEST = 'CORE_AUTH_VERIFY_PD_DEVICE_REQUEST';
var CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS = 'CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS';
var CORE_AUTH_VERIFY_PD_DEVICE_FAILURE = 'CORE_AUTH_VERIFY_PD_DEVICE_FAILURE';

var CORE_GET_DEVICE_INFO_REQUEST = 'CORE_GET_DEVICE_INFO_REQUEST';
var CORE_GET_DEVICE_INFO_SUCCESS = 'CORE_GET_DEVICE_INFO_SUCCESS';
var CORE_GET_DEVICE_INFO_FAILURE = 'CORE_GET_DEVICE_INFO_FAILURE';

var CORE_USER_CHECKIN_REQUEST = 'CORE_USER_CHECKIN_REQUEST';
var CORE_USER_CHECKIN_SUCCESS = 'CORE_USER_CHECKIN_SUCCESS';
var CORE_USER_CHECKIN_FAILURE = 'CORE_USER_CHECKIN_FAILURE';

var CORE_USER_CHECKOUT_REQUEST = 'CORE_USER_CHECKOUT_REQUEST';
var CORE_USER_CHECKOUT_SUCCESS = 'CORE_USER_CHECKOUT_SUCCESS';
var CORE_USER_CHECKOUT_FAILURE = 'CORE_USER_CHECKOUT_FAILURE';

var CORE_GET_DETAIL_TASKLIST_REQUEST = 'CORE_GET_DETAIL_TASKLIST_REQUEST';
var CORE_GET_DETAIL_TASKLIST_SUCCESS = 'CORE_GET_DETAIL_TASKLIST_SUCCESS';
var CORE_GET_DETAIL_TASKLIST_FAILURE = 'CORE_GET_DETAIL_TASKLIST_FAILURE';

var CORE_START_JOB_REQUEST = 'CORE_START_JOB_REQUEST';
var CORE_START_JOB_SUCCESS = 'CORE_START_JOB_SUCCESS';
var CORE_START_JOB_FAILURE = 'CORE_START_JOB_FAILURE';

var CORE_END_JOB_REQUEST = 'CORE_END_JOB_REQUEST';
var CORE_END_JOB_SUCCESS = 'CORE_END_JOB_SUCCESS';
var CORE_END_JOB_FAILURE = 'CORE_END_JOB_FAILURE';

var CORE_CREATE_DEVICE_REQUEST = 'CORE_CREATE_DEVICE_REQUEST';
var CORE_CREATE_DEVICE_SUCCESS = 'CORE_CREATE_DEVICE_SUCCESS';
var CORE_CREATE_DEVICE_FAILURE = 'CORE_CREATE_DEVICE_FAILURE';

var CORE_UPDATE_DEVICE_REQUEST = 'CORE_UPDATE_DEVICE_REQUEST';
var CORE_UPDATE_DEVICE_SUCCESS = 'CORE_UPDATE_DEVICE_SUCCESS';
var CORE_UPDATE_DEVICE_FAILURE = 'CORE_UPDATE_DEVICE_FAILURE';

var CORE_GET_ALL_PD_AX_LIST_REQUEST = 'CORE_GET_ALL_PD_AX_LIST_REQUEST';
var CORE_GET_ALL_PD_AX_LIST_SUCCESS = 'CORE_GET_ALL_PD_AX_LIST_SUCCESS';
var CORE_GET_ALL_PD_AX_LIST_FAILURE = 'CORE_GET_ALL_PD_AX_LIST_FAILURE';

var CORE_SEND_PD_TO_AX_REQUEST = 'CORE_SEND_PD_TO_AX_REQUEST';
var CORE_SEND_PD_TO_AX_SUCCESS = 'CORE_SEND_PD_TO_AX_SUCCESS';
var CORE_SEND_PD_TO_AX_FAILURE = 'CORE_SEND_PD_TO_AX_FAILURE';

var CORE_GET_DRAWING_INFO_REQUEST = "CORE_GET_DRAWING_INFO_REQUEST";
var CORE_GET_DRAWING_INFO_SUCCESS = "CORE_GET_DRAWING_INFO_SUCCESS";
var CORE_GET_DRAWING_INFO_FAILURE = "CORE_GET_DRAWING_INFO_FAILURE";

var CORE_GET_RF_PD_LIST_REQUEST = "CORE_GET_RF_PD_LIST_REQUEST";
var CORE_GET_RF_PD_LIST_SUCCESS = "CORE_GET_RF_PD_LIST_SUCCESS";
var CORE_GET_RF_PD_LIST_FAILURE = "CORE_GET_RF_PD_LIST_FAILURE";

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(532);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(244)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(41)(false);
// imports
exports.i(__webpack_require__(533), "");
exports.i(__webpack_require__(534), "");
exports.i(__webpack_require__(535), "");
exports.i(__webpack_require__(536), "");
exports.i(__webpack_require__(537), "");
exports.i(__webpack_require__(538), "");

// module
exports.push([module.i, ".fontMini,.module.errorModal .detailError{font-size:16px;font-size:1.6rem}.btn,.fontBody,.module.errorModal .detailError.detail,.module.inputForm .boxViewValue p,.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject,.module.layoutWithSidebar .menuSidebar,.module.layoutWithSidebar .sidebarBox .actionBox .userBox p,.module.layoutWithSidebar .sidebarBox .headerBox .text p,.module.popupUser .userContent .contentDetail .detailUser .email,.ui.button,p{font-size:18px;font-size:1.8rem;line-height:25px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.form,.ui.input{font-size:18px!important;font-size:1.8rem!important}.fontHeader,.module.customTable .boxNoData p,.module.errorModal .detailError.header,.module.header .menu-item.text,.module.header .menuMobile,.module.inputForm .headerBoxHeaderTap,.module.itemSettingBox .boxTextHeaderSetting p,.module.menuData .boxMenu .itemMenu p,.module.popupUser .userContent .contentDetail .detailUser .name{font-size:20px!important;font-size:2rem!important}.boxHeaderPage p,.fontHeaderBody,.fontHeaderPage,.module.loginForm .text-box p{font-size:32px;font-size:3.2rem}.fontSettingValueView,.module.itemSettingBox .boxTextValueSetting p{font-size:24px;font-size:2.4rem}.fontStep,.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{font-size:16px!important;font-size:1.6rem!important}.btn{font-weight:700!important;min-width:100px}.btnPicker>.ui.basic.button,.btnPicker>.ui.basic.button:active,.btnPicker>.ui.basic.button:hover{background-color:inherit!important;border:none;box-shadow:none!important}.ui.button.btnLogin{background-color:#000;color:#e0e0e0;margin:0;width:9rem;height:9rem;font-size:35px;margin-top:7rem;cursor:pointer}.ui.button.btnAdd{padding:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnAdd .i.icon,.ui.button.btnAdd i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnAddMinus{padding:0;width:30px;height:30px;color:#0f1a28;background-color:transparent;font-size:13px}.ui.button.btnAddMinus .i.icon,.ui.button.btnAddMinus i.icons{padding-right:2px!important}.ui.button.btnAddMinus.disable{color:#ababab}.btnAddBlueText,.ui.button.btnAddBlueText{padding:0 15px;margin:0;height:40px;border-radius:20px;color:#e0e0e0;background-color:#1e48f9;font-size:16px;min-width:100px;margin-left:5px}.btnAddText,.ui.button.btnAddText{padding:0 15px;height:30px;color:#e0e0e0;background-color:#1b2c57;margin-left:5px!important}.btnAddText.transfer,.btnAddTextInvert.transfer{background-color:#0f1a28;min-width:100px;height:50px!important;width:100%}.btnAddTextInvert,.ui.button.btnAddTextInvert{padding:0 15px;margin:0;height:30px;color:#1b2c57;background-color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnAddTextInvert.marginLeft5,.ui.button.btnAddTextInvert.marginLeft5{margin-left:5px!important}.btnAddTextInvert.reportSize,.ui.button.btnAddTextInvert.reportSize{height:100px;min-width:300px;font-size:20px}.btnAddTextInvert.reportSize:focus,.ui.button.btnAddTextInvert.reportSize:focus{-webkit-box-shadow:0 0 6px 5px rgba(255,0,0,.9);box-shadow:0 0 6px 5px rgba(255,0,0,.9)}.btnEditBlueText,.ui.button.btnEditBlueText{padding:0 15px;margin:0;height:30px;color:#e3e4e3;background-color:#1e48f9;font-size:13px;min-width:100px;margin-left:5px}.btnSubmitItemText,.ui.button.btnSubmitItemText{background-color:#f19fff}.btnCancelText,.btnSubmitItemText,.ui.button.btnCancelText,.ui.button.btnSubmitItemText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnCancelText,.ui.button.btnCancelText{background-color:#d83838}.btnCancelText.marginLeft5,.ui.button.btnCancelText.marginLeft5{margin-left:5px!important}.btnCancelText.reportSize,.ui.button.btnCancelText.reportSize{height:100px;min-width:300px;font-size:20px}.btnCancelEditText,.ui.button.btnCancelEditText{padding:0 15px;margin:0;height:30px;color:#353386;background-color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnCancelTextInvert,.ui.button.btnCancelTextInvert{color:#d83838;border:1px solid #d83838}.btnCancelTextInvert,.btnUpdate,.ui.button.btnCancelTextInvert,.ui.button.btnUpdate{padding:0 15px;margin:0;height:30px;background-color:#e3e4e3;font-size:13px;margin-left:5px;min-width:100px}.btnUpdate,.ui.button.btnUpdate{color:#383838;border:1px solid #e0e0e0}.btnAddItemText,.ui.button.btnAddItemText{background-color:#1e48f9}.btnAddItemText,.btnValidateText,.ui.button.btnAddItemText,.ui.button.btnValidateText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnValidateText,.ui.button.btnValidateText{background-color:#353386}.btnGencodeText,.ui.button.btnGencodeText{background-color:#119303}.btnEditText,.btnGencodeText,.ui.button.btnEditText,.ui.button.btnGencodeText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnEditText,.ui.button.btnEditText{background-color:#9646ff}.btnEditText.reportSize,.ui.button.btnEditText.reportSize{height:100px;min-width:300px;font-size:20px}.btnEditText.reportSize:focus,.ui.button.btnEditText.reportSize:focus{-webkit-box-shadow:0 0 6px 5px rgba(255,0,0,.9);box-shadow:0 0 6px 5px rgba(255,0,0,.9)}.btnEditYellowText,.ui.button.btnEditYellowText{padding:0 15px;margin:0;height:30px;color:#353386;background-color:#dde01a;font-size:13px;margin-left:5px;min-width:100px}.btnApproveText,.ui.button.btnApproveText{background-color:#119303}.btnApproveText,.btnBackText,.ui.button.btnApproveText,.ui.button.btnBackText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnBackText,.ui.button.btnBackText{background-color:#f7213b}.ui.button.btnView{padding:0;margin:0;width:30px;height:30px;color:#353386;font-size:13px}.ui.button.btnView .i.icon,.ui.button.btnView i.icons{padding-right:2px!important;color:#353386}.ui.button.btnSearch{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnSearch .i.icon,.ui.button.btnSearch i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnSearchInvert{padding:0;margin:0;width:40px;height:40px;color:#1b2c57;background-color:#e0e0e0;font-size:13px}.ui.button.btnSearchInvert .i.icon,.ui.button.btnSearchInvert i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnReloadData{padding:0;margin:0;width:40px;height:40px;color:#1b2c5721;background-color:#e0e0e03d;font-size:13px}.ui.button.btnReloadData .i.icon,.ui.button.btnReloadData i.icons{padding-right:2px!important;color:#e0e0e0}.btnUploadFile,.ui.button.btnUploadFile{padding:0 15px;margin:0;height:49px;background-color:#fff;font-size:13px;margin-left:5px;min-width:100px;border:1px solid;border-color:#dededf}.ui.button.btnDeleteFile{padding:0;margin:0;width:20px;height:20px;color:#e70000;background:hsla(0,0%,100%,0);font-size:13px}.ui.button.btnDeleteFile .i.icon,.ui.button.btnDeleteFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnDownloadFile{padding:0;margin:0;width:20px;height:20px;color:#1b2c57;background:hsla(0,0%,100%,0);font-size:18px}.ui.button.btnDownloadFile .i.icon,.ui.button.btnDownloadFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.addNewItem{font-size:3rem;height:1vh;background:url(/assets/images/btn_add.png);background-repeat:no-repeat;background-size:contain;padding-left:1vh}.ui.button.btnEdit{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#dde01a;font-size:13px;margin-left:5px}.ui.button.btnEdit .i.icon,.ui.button.btnEdit i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnDelete{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#d83838;font-size:13px;margin-left:5px}.ui.button.btnDelete .i.icon,.ui.button.btnDelete i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnConfirm{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#06be2e;font-size:13px;margin-left:5px}.ui.button.btnConfirm .i.icon,.ui.button.btnConfirm i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnActionModal{padding:0;margin:0;width:30px;height:30px;color:#000;background-color:unset;font-size:13px;margin-left:5px}.ui.button.btnActionModal .i.icon,.ui.button.btnActionModal i.icons{padding-right:2px!important;color:#e0e0e0}.iconBtnConfirm{padding:0;margin:0!important;width:30px!important;height:30px!important;color:#e0e0e0;background-color:#0b6ddd;font-size:13px!important;border-radius:3px;padding-top:7.5px}.btnIcon,.ui.circular.btnIcon{width:40px;height:40px;margin-top:20px;padding:0!important;padding-right:2px!important}.btnIcon .ui.circular.button>.icon,.ui.circular.btnIcon .ui.circular.button>.icon{padding-right:2px!important;margin-top:5px!important}.btnIcon i.icon:hover,.ui.circular.btnIcon i.icon:hover{background-color:inherit!important;color:inherit!important;border:inherit!important}.ui.circular.btnIcon>.icon{font-size:20px;padding-top:5px;padding-right:2px!important}.ui.button.btnDisplay{height:23vh;width:23vh;background-repeat:no-repeat;background-size:cover}.ui.button.btnDisplay.login{background:url(\"/assets/images/icon_card.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.loginFail{background:url(\"/assets/images/icon_card_fail.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.loginAdmin{background:url(\"/assets/images/button/btn_card_admin.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.btnStart{background:url(\"/assets/images/button/btn_start.png\");background-size:100%}.ui.button.btnDisplay.btnStart.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnStart.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnResume{background:url(\"/assets/images/button/btn_resume.png\");background-size:100%}.ui.button.btnDisplay.btnResume.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnResume.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnLogout{background:url(\"/assets/images/button/btn_logout.png\");background-size:100%}.ui.button.btnDisplay.btnLogout.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnLogout.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnStop{background:url(\"/assets/images/button/btn_stop.png\");background-size:100%}.ui.button.btnDisplay.btnStop.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnStop.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnPause{background:url(\"/assets/images/button/btn_pause.png\");background-size:100%}.ui.button.btnDisplay.btnPause.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnPause.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnFinish{background:url(\"/assets/images/button/btn_finish.png\");background-size:100%}.ui.button.btnDisplay.btnFinish.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnFinish.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnCheckInOut{background:url(\"/assets/images/button/btn_checkInOut.png\");background-size:100%}.ui.button.btnDisplay.btnCheckInOut.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnCheckInOut.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnHelp{background:url(\"/assets/images/button/btn_help.png\");background-size:100%}.ui.button.btnDisplay.btnHelp.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnHelp.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnEnter{background:url(\"/assets/images/button/btn_confirm.png\");background-size:100%}.ui.button.btnDisplay.btnEnter.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnEnter.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnBackDisplay{background:url(\"/assets/images/button/btn_back.png\");background-size:100%}.ui.button.btnDisplay.btnBackDisplay.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnBackDisplay.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnArrowUp{background:url(\"/assets/images/button/btn_arrow_up.png\");background-size:100%}.ui.button.btnDisplay.btnArrowUp.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnArrowUp.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnArrowDown{background:url(\"/assets/images/button/btn_arrow_down.png\");background-size:100%}.ui.button.btnDisplay.btnArrowDown.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnArrowDown.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnSettings{background:url(\"/assets/images/button/btn_settings.png\");background-size:100%}.ui.button.btnDisplay.btnSettings.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnSettings.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnDeleteData{background:url(\"/assets/images/button/btn_delete.png\");background-size:100%}.ui.button.btnDisplay.btnDeleteData.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnDeleteData.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnMenuSelect{width:77vw;margin-bottom:1.5vh;font-size:3.7em;height:12.5vh;background-color:#fff}.ui.button.btnDisplay.btnMenuSelect:focus{border-radius:unset!important;color:#353386!important;background-color:#ff0048}.btnAddText,.ui.button.btnAddText{padding:0 30px;margin:0;height:40px;color:#272727;background-color:#f2711c;font-size:13px;min-width:100px;margin-left:5px}.btnAddUpdate,.btnAddView,.ui.button.btnAddUpdate,.ui.button.btnAddView{padding:9px;height:32px;color:#272727;font-size:15px;min-width:62px;margin:auto;line-height:16px}.btnAddView,.ui.button.btnAddView{background-color:#f2711c}.ui.checkbox,.ui.dropdown,.ui.form,.ui.form .field>label,.ui.form textarea,.ui.input,.ui.input input,.ui.steps .step .title,.ui[class*=\"left icon\"].input>input,a,body,button,div,h1,h2,h3,h4,h5,h6,p,span{font-family:roboto}body{background-color:#f9f9f9}p{margin:0;color:#7c7c7c}.ui.checkbox,.ui.checkbox label,.ui.dropdown,.ui.form,.ui.form textarea,.ui.input,.ui.input input{color:#7c7c7c!important}.gridNogMargin,.gridNoPaddingMargin,.gridNoPaddingMargin>.column,.gridNoPaddingMargin>.row,.gridNoPaddingMargin>.row>.column{padding:0!important;margin:0!important}.gridColumnNoPaddingTB{padding-top:0!important;padding-bottom:0!important}.contentHeightMax{height:100%}.scrollListFormBox{height:140px;overflow-y:scroll;padding:1rem;background-color:#353386}.boxDatePicker{width:200px}.boxDatePicker.fluid{width:100%}.listSelectAll{padding-bottom:.42857143em;padding-top:.42857143em;background-color:#fff}.iWAAXb{padding:0 25px 0 10px!important}.ui.dimmer{z-index:2000!important;position:fixed!important}.iconMenuRowTable{cursor:pointer}.boxHeaderPage p{font-weight:700}.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-khtml-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}@media only screen and (max-width:767px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:10px;padding-right:10px}.customContainer .boxHeader.desktop,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop{display:none}.customContainer .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent .contentBox .boxBody .boxContent{padding-top:50px}.customContainer .module.transfer .desktop,.module.layoutMaster .module.transfer .desktop{display:none}}@media only screen and (min-width:768px) and (max-width:991px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:30px;padding-right:30px}.customContainer .boxHeader.desktop,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop,.module.layoutMaster .module.transfer .mobileSize{display:none}}@media only screen and (min-width:992px) and (max-width:1199px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:60px;padding-right:30px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1200px) and (max-width:1919px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:100px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1920px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:150px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize{display:none}}.scrollListFormBox{height:200px;overflow-y:auto;overflow-x:hidden;border:1px solid #e6e7e8;border-radius:.285714rem;background-color:#fff;padding:10px}.cursor-pointer{cursor:pointer}.div-flex{display:flex}p.white-space{white-space:normal}p.textDetailModal,p.white-space{color:rgba(0,0,0,.87);font-size:16px}b.textSubjectModal{font-size:16px;color:#2c75b7}.tooltip{position:relative;display:inline-block}.tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;z-index:1}.tooltip:hover .tooltiptext{visibility:visible}.MuiTypography-body1{font-size:1.5rem!important}.MuiTypography-body2{font-size:1.25rem!important}.MuiTypography-caption{font-size:1.2rem!important}.MuiTypography-subtitle1{font-size:2rem!important}.MuiButton-root{font-size:1.25rem!important}.MuiPickersModal-dialogRoot{width:370px!important}.MuiPickersBasePicker-pickerView{min-width:370px!important;width:370px}.flagMenu.active{width:30px;opacity:1;cursor:pointer}.flagMenu{opacity:.5;width:30px;cursor:pointer}.paddingLeft5{padding-left:5px}.padding10{padding:10px}.padding15{padding:15px}.padding20{padding:20px}.marginLeft5{margin-left:5px}.marginLeft10{margin-left:10px}.margin10{margin:10px}.ui.steps{border:none}.kQuRQn{overflow-x:unset!important;overflow-y:unset!important}.iBMnVw{cursor:pointer}.eRFaRs{overflow-y:unset!important}.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{border-radius:5px;min-width:100px;height:50px;background-color:#e0e0e0;color:#7c7c7c}.ui.steps .step:after{display:none!important}.ui.steps .step.active,.ui.steps .step.active:hover{background-color:#353386!important}.ui.steps .step.active .title,.ui.steps .step.active .title:hover{color:#e0e0e0!important}.ui.steps a.step:hover{background-color:#e0e0e0!important}.ui.form .disabled.field,.ui.form .disabled.fields .field,.ui.form .field.disabled>label,.ui.form .field :disabled,.ui.form .fields.disabled>label{opacity:1}.ui.form .field>label{min-height:20px}.module.itemSettingBox .boxTextHeaderSetting p,.module.itemSettingBox .boxTextValueSetting p,.textOverflow{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ui.menu{background-color:#f9f9f9}.ui.form .field>.selection.dropdown{min-width:auto}.ui.selection.active.dropdown .menu{width:150px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.dropdown>.text,.ui.form,.ui.input{font-size:16px!important;width:100%}.ui.input.error>input{background-color:#fff6f6;border-color:#e0b4b4;color:#9f3a38;-webkit-box-shadow:none;box-shadow:none}.ui.form .field .ui.input input,.ui.form .fields .field .ui.input input{padding:5px!important;font-weight:200}.MuiTableSortLabel-root{font-size:16px;padding:5px 0!important;font-weight:800}.MuiTableRow-head,.MuiTableRow-hover,.MuiTableRow-root{padding:15px}.MuiTableCell-paddingNone{padding:inherit!important}.MuiTableCell-root,.MuiTablePagination-select{font-size:16px!important;font-weight:300!important}.footer{position:fixed;bottom:0;right:0;padding:20px 10px;text-align:right;background-color:#f9f9f9;width:100vw}.footer.center{text-align:center}.footer.mobile{padding:10px}.ui.form .field .ui.input,.ui.form .fields .field .ui.input,.ui.form .wide.field .ui.input{height:40px}.ui.steps .step .title{font-size:16px}.ui.disabled.input,.ui.input:not(.disabled) input[disabled]{opacity:.7}.ui.disabled.dropdown,.ui.disabled.dropdown .ui.dropdown>.text,.ui.disabled.input>input,.ui.disabled.input>input .ui.dropdown>.text,.ui.input:not(.disabled) input[disabled],.ui.input:not(.disabled) input[disabled] .ui.dropdown>.text{background-color:#dadada;color:#5a5a5a!important}.ui.form .inline.fields{margin:0}.ui.table thead{width:100%}.ui.sortable.table thead th{font-size:19px;text-align:center;font-weight:700;background-color:#e4e4e4}.ui.celled.table tr td,.ui.celled.table tr th{font-size:17px;overflow-wrap:anywhere}table tbody tr:nth-child(2n){background:#f7f5f5}.ui.sortable.table thead th.noSort:hover{background:#f7f7f7;color:inherit;cursor:inherit}.cursorPointer{cursor:pointer}.marginBottom10{margin-bottom:10px!important}.width100{width:100%!important}.homePage{width:100%;display:flex!important;justify-content:center;align-items:center!important;margin-top:35vh!important;text-align:center}.pageNotFound img.ui.image{display:inline-flex;width:250px}.pageNotFound h1{font-size:26px}.pageNotFound .char404{font-size:36px;color:#ff2d2d}@media{.page-break{display:none}}@media print{body,html{-webkit-print-color-adjust:exact}}@media print{.page-break{page-break-before:always}}.module.loadableController,.module.loadableRoute{height:100vh;display:flex;justify-content:center;align-items:center}.module.loadableController{position:fixed;overflow:auto}.module.switchLanguage{display:flex}.module.switchLanguage .language-item.select{background-color:#ccc}.wrapperChangeLang{display:flex;align-items:center;justify-content:center;margin-right:8px;border-radius:24px}.wrapperChangeLang .wrapper{display:flex;padding:8px;align-items:center;border:none;box-shadow:none;border-right:1px solid #cfcfcf;border-radius:0}.wrapperChangeLang .wrapper .btnFlag{display:flex;justify-content:center;align-items:center;padding:4px 8px;cursor:pointer;width:30px;height:30px;margin:0;border-radius:50%;margin:0 1px}.wrapperChangeLang .wrapper .flag{margin:0}.wrapperChangeLang .wrapper .active{box-shadow:inset 0 0 4px #949494;background:#f5f5f5;border:0}.module.errorBoundary .grid-header{padding-top:50px}.module.header{margin:0;box-shadow:0 4px 12px 0 rgba(0,0,0,.05)!important;background-color:#353386!important;position:absolute;width:100%;margin:0!important;top:0;z-index:2000}.module.header .logo-box{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.module.header .logo-box img{display:inline-block;max-width:100%;max-height:100%}.module.header .menu-item.logoUser{padding-top:0;padding-bottom:0}.module.header .menu-item.logo{padding:0;width:150px;height:50px}.module.header .menu-item.text p{color:#353386!important;font-weight:700}.module.header .menuBoxDesktop{width:100%}.module.header .menuBoxDesktop .menuRight{width:100%;height:100%;justify-content:flex-end}.module.header .menuBoxMobile{width:100%;display:flex}.module.header .menuMobile{padding:0!important}.module.header .menuMobile>i{display:none!important}.module.header .imageMenuMobile>i{margin:0!important}.module.header .itemMenuDropdown,.module.header .subMenuDropdown{width:180px}.module.header .userImage{width:40px;height:40px;border-radius:50%;overflow:hidden;cursor:pointer}.module.header .userImage img{width:100%;height:100%}.module.errorModal>.header{background-color:#353386}.module.errorModal>.actions,.module.errorModal>.header{border:none!important;padding:15px!important}.module.errorModal .boxHeaderContent{height:100px;display:flex;justify-content:center;align-items:center}.module.errorModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:15px;opacity:.3;cursor:pointer}.module.errorModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.errorModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.errorModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.errorModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.errorModal .itemError{padding:10px 0!important}.module.errorModal .detailError{margin:0}.module.errorModal .detailError.header{font-weight:700}.module.errorModal .boxErrorParam{padding-left:15px}.module.actionModal .ui.button{font-size:16px;padding:10px;margin:0!important;background-color:#1b2c57;color:#ccc}.module.actionModal .danger p,.module.actionModal .warning p{color:#353386}.module.actionModal .danger .dialogHeader{padding-top:5px}.module.actionModal .danger .boxImageClose{margin-top:15px}.module.actionModal .headerBG{height:65px}.module.actionModal .headerBG.danger,.module.actionModal .headerBG.detail,.module.actionModal .headerBG.warning{background-color:#e6e7e8}.module.actionModal>.actions,.module.actionModal>.header{border:none!important;padding:15px!important}.module.actionModal .boxHeaderContent{display:flex;justify-content:center;align-items:center;flex-direction:column}.module.actionModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:-5px;opacity:.3;cursor:pointer}.module.actionModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.actionModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.actionModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxTextHeader p{font-size:16px;font-weight:700}.module.actionModal .boxTextDetail{min-height:9vh;max-height:60vh;overflow-y:scroll;overflow-x:hidden}.module.actionModal .boxAction{margin-top:1.5rem;position:absolute;z-index:999;text-align:center;width:100%;margin-bottom:5px}.module.inputForm{width:100%}.module.inputForm .formField{margin:0!important}.module.inputForm .formField.pickerType{position:relative}.module.inputForm .disabledInput{opacity:.45}.module.inputForm .boxViewValue{background-color:#fff;padding:1rem}.module.inputForm .boxViewValue p{margin:0!important}.module.inputForm .boxViewValue.mini{width:20%}.module.inputForm .boxViewValue.small{width:50%}.module.inputForm .labelInput p{margin:0!important}.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject{font-weight:700;display:inline-block}.module.inputForm .labelInput .required{color:red}.module.inputForm .boxDatePicker>.MuiFormControl-root{display:none!important}.module.inputForm .textValid{color:red}.module.inputForm .hidePicker{display:none}.module.inputForm .inputFile,.module.inputForm .inputFile input,.module.inputForm .inputPicker,.module.inputForm .inputPicker input{opacity:unset!important}.module.inputForm .btnPicker,.module.inputForm .btnUploadFile{position:absolute;top:50%;right:0;transform:translateY(-50%)}.module.inputForm .btnPicker button,.module.inputForm .btnUploadFile button{transform:translateX(-30%)}.module.inputForm .boxColumSubjectTop{padding-top:1rem!important}.module.inputForm .headerBoxHeaderTap{font-weight:700}.module.inputForm .editorInputHtml{height:275px!important;border:1px solid #f1f1f1!important;padding:5px!important;border-radius:2px!important;background-color:#fff}.module.inputForm .boxInputUploadFile{display:flex}.module.inputForm .boxInputUploadFile .inputBox{flex:1}.module.inputForm .boxInputUploadFile .actionBox{flex:0 0 auto}.module.inputForm .boxInputUploadFile .actionBox button{height:100%;margin-right:0;margin-left:.5rem}.module.popupUser .userContent{display:flex;widows:200px}.module.popupUser .userContent .contentImage{flex:0 0 auto;width:70px;height:70px;border-radius:50%;overflow:hidden}.module.popupUser .userContent .contentImage img{width:100%;height:100%}.module.popupUser .userContent .contentDetail{padding-left:1rem;flex:1}.module.popupUser .userContent .contentDetail .detailUser .name{font-weight:700}.module.popupUser .userAction{border-top:1px solid #ccc;display:flex;justify-content:flex-end;margin-top:1rem;padding-top:1rem}.module.popupUser .userAction button{padding-top:.5rem;padding-bottom:.5rem}.holiday{background:#f1f1f1}.speciaoHliday{background:#e85e6c}.fc-time-area .fc-rows td>div{height:100px!important}.fc-highlightSelect{background-color:#4183c4;height:99px!important;margin-top:1px!important;margin-left:1px!important}.fc-eventCustom{background-color:red;border:1px solid #fff}.fc-holiday{background-color:#ccc}.module.customTable{padding-bottom:0;height:100%;width:100%;overflow:hidden;overflow-x:auto}.module.customTable .boxNoData{padding:3rem 0}.module.customTable .boxNoData p{font-weight:700}.module.customTable .ui.icon.button{padding:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.module.customTable .ui.icon.button .i.icon,.module.customTable .ui.icon.button i.icons{padding-right:2px!important;color:#e0e0e0}.module.customTable .ui.icon.button.btnUndo{background-color:#279b54;margin-right:5px;color:#fff}.module.customTable .ui.icon.button.btnDelete{background-color:#d1052c;margin-right:5px;color:#fff}.layoutHelper{text-align:left}.layoutHelper .helperKey{position:fixed;left:0;margin-left:10px;margin-top:-5px;display:inline-flex}.layoutHelper .helperKey.modal{position:unset}.layoutHelper .helperKey .keyGuide{margin-top:10px;font-size:16px;color:#000!important}.layoutHelper .helperKey .box-button{height:45px;width:60px;border:1px solid #d4d4d4;text-align:center;padding:2px;border-radius:2px;margin:0 5px}.layoutHelper .helperKey .box-button p{color:#000!important}.layoutHelper .helperKey .box-button p.iconKey{font-size:22px}.layoutHelper .helperKey .box-button p.iconKey.plus{font-size:30px}.layoutHelper .helperKey .box-button p.textKey{font-size:10px;margin-top:-5px}.actionsLeftHelperKey{padding-top:15px;text-align:left!important}.module.layoutWithSidebar .sidebarBox{position:fixed;display:flex;flex-direction:column;top:0;bottom:0;left:0;width:250px;background-color:#353386;overflow-x:hidden;flex:1}.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px;display:flex;justify-content:center;align-items:center;flex-direction:column}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox{max-width:230px;height:60px}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox img{height:100%;display:block}.module.layoutWithSidebar .sidebarBox .headerBox .text p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox{border-top:1px solid #e6e7e8}.module.layoutWithSidebar .sidebarBox .actionBox .userBox p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox{margin-top:10px}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox button{padding-top:5px;padding-bottom:5px;width:100%}.module.layoutWithSidebar .sidebarBox .headerBox{border-bottom:1px solid #353386}.module.layoutWithSidebar .sidebarBox .actionBox,.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px}.module.layoutWithSidebar .sidebarBox .menuBox{flex:1;overflow-y:auto}.module.layoutWithSidebar .bodyBox{margin-left:250px;min-width:550px;padding:2rem}.module.layoutWithSidebar .menuSidebar{width:100%;margin:0!important;min-height:unset;border:none;border-radius:unset}.module.layoutWithSidebar .menuSidebar .item{margin:0!important;color:#353386;font-weight:700;background-color:#353386;border-radius:unset!important}.module.layoutWithSidebar .menuSidebar .active.item,.module.layoutWithSidebar .menuSidebar .item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar .menuSidebar .active.item{margin:0!important;font-weight:700;cursor:unset!important}.module.layoutWithSidebar .menuSidebar .active.item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar{width:10px;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-thumb{border-radius:0;background-color:#353386;border:2px solid #353386}.module.layoutBlank{height:100vh;height:calc(var(--vh, 1vh) * 100);overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center}.module.layoutMaster,.module.layoutMaster .boxBody{background-color:#f9f9f9;height:100vh}.module.layoutMaster .boxBody{display:flex;flex:1;flex-direction:column}.module.layoutMaster .boxBody .boxHeader.expand{width:250px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage{width:100%;padding:5px;display:inline-flex;height:50px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem{width:30%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem img.ui.image,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem img.ui.image{margin-top:10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem{width:70%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName{margin-top:-5px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName p{padding-top:5px;font-size:14px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .logout,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .logout{margin-top:-10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText{margin-top:10px;font-weight:400;text-align:left}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText p{font-size:13px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom{left:140px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom p{padding-left:15px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom .language{padding-left:8px}.module.layoutMaster .boxBody .boxHeader.expand .item.logo img.ui.image{width:180px;height:40px}.module.layoutMaster .boxBody .boxHeader{position:fixed;left:0;z-index:200;height:100vh;width:85px;background-color:#f9f9f9;border-right:1px solid #ccc;box-shadow:3px 0 7px #ccc;border-top-right-radius:10px}.module.layoutMaster .boxBody .boxHeader .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:10px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader .item.logo img.ui.image{width:40px;height:40px}.module.layoutMaster .boxBody .boxHeader .item{height:50px;overflow:hidden;cursor:pointer;width:100%}.module.layoutMaster .boxBody .boxHeader .item .itemIcon,.module.layoutMaster .boxBody .boxHeader .item .userImage{width:100%;text-align:center;height:40px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon img.ui.image,.module.layoutMaster .boxBody .boxHeader .item .userImage img.ui.image{left:45%;transform:translate(-45%);width:30px;height:30px;border-radius:5px;margin-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .itemIcon .logout,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .logout{text-align:left}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName{font-weight:700;padding-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName p,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName p{text-overflow:ellipsis;white-space:nowrap;height:30px;overflow:hidden;width:20ch}.module.layoutMaster .boxBody .boxHeader .item i.icon{padding-top:5px;text-align:center;font-size:30px;margin:0}.module.layoutMaster .boxBody .boxHeader .item .logout{cursor:pointer}.module.layoutMaster .boxBody .boxHeader .item .logout p{font-size:12px}.module.layoutMaster .boxBody .boxHeader .item.active{background-color:#e8e8e8}.module.layoutMaster .boxBody .boxHeader .item.line{border-top:1px solid #ccc;width:100%;height:1px;padding:0}.module.layoutMaster .boxBody .boxHeader .item.bottom{position:fixed;left:0;bottom:0;display:inline-table;padding:0;padding-bottom:10px;width:250px}.module.layoutMaster .boxBody .boxHeader .item.bottom p{font-size:12px;padding-left:8px}.module.layoutMaster .boxBody .boxHeader .item.bottom .language img.ui.image{display:inline;width:25px}.module.layoutMaster .boxBody .boxContent{padding-bottom:50px;height:100vh}.module.layoutMaster .boxBody .boxContent .contentBox{background-color:#f9f9f9;padding-top:2rem;width:100%;padding-bottom:100px}.module.layoutMaster .boxBody .boxHeader.mobile{width:100vw;z-index:200;position:fixed;left:0;height:45px;background-color:#f9f9f9}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo img.ui.image{width:30px;height:30px}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:3px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader.mobile.expand{height:100%;width:80vw}.module.layoutMaster .boxBody .boxHeader.mobile.expand .item.bottom{height:100vh;top:80%;left:50vw}.module.layoutMaster .logoImageHeader img{width:8rem;margin:0;display:inline-flex}.module.menuData .boxMenu{display:flex;flex-direction:row}.module.menuData .boxMenu .itemMenu{border:1px solid #353386;text-align:center;min-width:140px;padding:5px 0;cursor:pointer;background-color:#353386;transition:color .5s,background-color .5s}.module.menuData .boxMenu .itemMenu p{font-weight:700;color:#353386!important}.module.menuData .boxMenu .itemMenu.active{background-color:#353386}.module.menuData .boxMenu .itemMenu.active p{color:#353386!important}.module.menuData .boxMenu .itemMenu:hover{background-color:#353386}.module.menuData .boxMenu .itemMenu:hover p{color:#353386!important}.module.menuData .boxMenu .itemMenu:first-child{border-top-left-radius:5px;border-bottom-left-radius:5px}.module.menuData .boxMenu .itemMenu:last-child{border-top-right-radius:5px;border-bottom-right-radius:5px}.overflowWrap{overflow-wrap:anywhere;align-self:center}.menuRightData{float:right}.txtFullName{font-size:18px}.module.layoutDisplay{background-color:#111a26;height:100vh;height:calc(var(--vh, 1vh) * 100);overflow-x:hidden;overflow-y:hidden;display:flex;justify-content:center;align-items:center;flex:1;padding:15px}.module.layoutDisplay .headerSection{position:absolute;top:0;height:5vh;width:100vw}.module.layoutDisplay .headerSection .headerText{padding-right:3vw;padding-top:1.2vh;text-align:right;font-size:1.8em;color:#fff}.module.layoutDisplay .contentSection{width:100%}.module.layoutDisplay.backgroundBlack{background-color:#111a26}.module.layoutPD{background-color:#fff;height:100vh;height:calc(var(--vh, 1vh) * 100);display:flex;justify-content:center;flex:1;padding:24px 40px}.module.layoutPD .headerSection{position:absolute;top:0;height:5vh;width:100vw}.module.layoutPD .headerSection .headerText{padding-right:3vw;padding-top:1.2vh;text-align:right;font-size:1.8em}.module.layoutPD .contentSection{width:100%}.module.layoutDisplay.backgroundBlack{background-color:#fff}.module.login{text-align:center;margin-top:-50px}.module.login .logoImage img{width:45rem;margin:0;display:inline-flex}.module.login .loginButton{padding-top:30px}.module.loginForm .image-box{display:flex;justify-content:center;align-items:center}.module.loginForm .image-box .image{max-width:100%}.module.loginForm .image-box .image img{width:100%;display:block}.module.loginForm .text-box{text-align:left}.module.loginForm .text-box p{margin:0;font-weight:700}.module.itemSettingBox{width:100%}.module.itemSettingBox .boxTextValueSetting{height:70px;display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextValueSetting p{font-weight:700}.module.itemSettingBox .boxTextValueSetting img{width:100%;max-height:100%;display:block}.module.itemSettingBox .boxTextValueSetting .btnAction{position:absolute;right:0;top:0}.module.itemSettingBox .boxTextHeaderSetting{display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextHeaderSetting p{font-weight:700}.module.itemMailContentBox{width:100%}.module.itemMailContentBox .boxEnabled{display:flex}.module.itemMailContentBox .boxEnabled p{font-weight:700;margin-right:1rem}.module.itemMailContentBox .boxMailContent .boxContent .subject,.module.itemMailContentBox .boxMailContent .boxSubject .subject{font-weight:700;margin:0}.module.itemMailContentBox .boxMailContent .boxContent .detail,.module.itemMailContentBox .boxMailContent .boxSubject .detail{margin-left:1rem}.reportForm .stepHeader h1{color:#353386}.reportForm .contentReportInfomation{display:inline-flex;height:220px;overflow-y:scroll}.reportForm .accordionItem{display:inline-flex}.reportForm .accordionItem h1{margin:0;color:#353386}.reportForm .accordionItem i.icon{margin:7px 0 0!important}.reportForm .subItem2{padding:15px 40px;border:2px solid rgba(34,36,38,.15);border-radius:5px;margin:0 10px;margin-bottom:20px}.reportForm .subItem2 :last-child{margin-bottom:0}.reportForm .subItemError{background-color:#fba7a773;color:#4e4e4e}.reportForm .noMargin{margin:0!important}.reportForm .dataLabelItem{height:20px;display:inline-flex;position:absolute;padding-left:1rem}.reportForm .viewSummaryItem{padding:10px 30px}.reportForm .viewSummaryItem .generateCode{padding:10px;border:1px dotted #b8b8b8;border-radius:5px;background-color:#d5eafd69}.reportForm .viewSummaryItem .generateCode h2{padding:10px 0}.reportForm .error{color:red}.reportForm .viewSummaryHeader{display:contents;font-size:20px}.reportForm .viewSummarySubHeader{font-size:17px}.reportForm .checkBoxAssambly,.reportForm .radioSpecial{font-size:14px!important;padding-bottom:14px}.reportForm .btnRightConfirm{float:right;vertical-align:middle}.reportForm .tubeItem{padding:15px 20px;border:1px dotted #ccc;border-radius:10px;margin-bottom:5px}.reportForm .finItem,.reportForm .plateItem{padding:10px 25px!important;border:1px dotted #ccc;border-radius:10px;background-color:#f3f3f3;margin-bottom:5px}.reportForm .finItem.validateError,.reportForm .plateItem.validateError{background-color:#fde5e5}.reportForm .accordionError,.reportForm .ui.styled.accordion .title.accordionError{background-color:#ffc2c2}.reportForm .accordionSuccess,.reportForm .ui.styled.accordion .title.accordionSuccess{background-color:#d0ffc2}.actionLog{margin-top:50px}.actionLog .viewCommentHeader{font-size:small}.module.drawing{padding:20px 0}.module.drawing .header{width:80vw;position:fixed;z-index:100}.module.drawing .header .addDrawing{width:45px;height:45px;background-color:#f9f9f9;border:1px solid #ccc;margin:0;padding:0;margin-top:1rem}.module.drawing .header .addDrawing .icon{color:#ccc;font-size:28px;width:100%;height:100%;margin-top:10px!important}.module.drawing .header .tableDrawingHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.module.drawing .header .tableDrawingHeader .th{text-align:center;padding:10px;font-size:14px;font-weight:600}.module.drawing .header .tableDrawingHeader .drawingNo{width:20%}.module.drawing .header .tableDrawingHeader .customerCode,.module.drawing .header .tableDrawingHeader .status{width:15%}.module.drawing .header .tableDrawingHeader .drawingRev{width:5%}.module.drawing .header .tableDrawingHeader .action,.module.drawing .header .tableDrawingHeader .coilSize,.module.drawing .header .tableDrawingHeader .customerName,.module.drawing .header .tableDrawingHeader .pipeType{width:20%}.module.drawing .drawingContent{padding-top:13rem}.module.drawing .drawingContent .tableDrawingContent{width:81vw;height:70vh;overflow:hidden;overflow-y:scroll;padding:10px 0}.module.drawing .drawingContent .tableDrawingContent .tr{display:inline-flex;width:80vw;color:#757575;border-bottom:1px solid #ccc}.module.drawing .drawingContent .tableDrawingContent .tr:hover{background-color:#e6e6e6;color:#000}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnAdd:disabled,.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnDelete:disabled,.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnView:disabled{opacity:.4!important}.module.drawing .drawingContent .tableDrawingContent .tableItem{padding:10px}.module.drawing .drawingContent .tableDrawingContent .tr:last-child{border:none}.module.drawing .drawingContent .tableDrawingContent .drawingRev,.module.drawing .drawingContent .tableDrawingContent .status{text-align:center}.module.drawing .drawingContent .tableDrawingContent .drawingNo{width:20%}.module.drawing .drawingContent .tableDrawingContent .customerCode,.module.drawing .drawingContent .tableDrawingContent .status{width:15%}.module.drawing .drawingContent .tableDrawingContent .drawingRev{width:5%}.module.drawing .drawingContent .tableDrawingContent .action,.module.drawing .drawingContent .tableDrawingContent .coilSize,.module.drawing .drawingContent .tableDrawingContent .customerName,.module.drawing .drawingContent .tableDrawingContent .pipeType{width:20%}.module.drawing .drawingContent .tableDrawingContent .coilSize,.module.drawing .drawingContent .tableDrawingContent .customerCode,.module.drawing .drawingContent .tableDrawingContent .customerName,.module.drawing .drawingContent .tableDrawingContent .drawingNo,.module.drawing .drawingContent .tableDrawingContent .drawingRev,.module.drawing .drawingContent .tableDrawingContent .pipeType,.module.drawing .drawingContent .tableDrawingContent .status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px}.module.drawing .drawingContent .tableDrawingContent .action .btnAdd,.module.drawing .drawingContent .tableDrawingContent .action .btnAdd:disabled,.module.drawing .drawingContent .tableDrawingContent .action .btnDelete,.module.drawing .drawingContent .tableDrawingContent .action .btnDelete:disabled,.module.drawing .drawingContent .tableDrawingContent .action .btnView,.module.drawing .drawingContent .tableDrawingContent .action .btnView:disabled{margin-right:5px;background-color:#cecece;color:#fffefe;opacity:1!important}.module.drawing .drawingContent .tableDrawingContent .action .btnDelete{margin:0}.module.drawing .drawingContent .drawingShowAllContent{text-align:center;width:80%;z-index:200;padding:0;display:inline;position:absolute}.module.drawing .drawingContent .drawingShowAllContent .ui.button{font-size:16px;background-color:inherit;color:#1b2c57}.module.drawing .drawingContent .drawingShowAllContent .ui.button .icon{margin-left:10px}.drawingInfo .btnAddText{margin-bottom:2px!important}.drawingInfo .info{overflow:hidden;border:1px solid gray;border-radius:10px;padding:10px}.drawingInfo .info h1{text-align:center}.drawingInfo .info .btnDownloadFile{display:contents}.drawingInfo .info .download.icon{margin-left:10px!important}.module.home .topUserSubject{font-size:15px;font-weight:500;color:#4183c4}.module.home .topUserContent{font-size:13px}.module.home .topUserTitle{color:#4183c4;font-size:20px;font-weight:900}.module.home .card{padding:10px;margin:10px}.module.home .description{margin-top:15px!important}.module.home input,.module.home input[type=text]{border:1px solid #ccc;padding:10px;border-radius:5px;font-size:14px;color:#5d5d5d}.module.home .react-datepicker,.module.home .react-datepicker-time__header,.module.home .react-datepicker-year-header,.module.home .react-datepicker__current-month{font-size:1.4rem}.module.home p{font-size:16px;color:#5d5d5d}.module.home .controlButton{padding-top:30px}.module.home .title{font-size:20px;font-weight:900}.module.info{padding:3rem}.module.info .subject{font-size:16px;text-decoration:underline}.module.info .content{line-height:26px;padding:20px 0}.module.info .content ol.ui.list li{padding-bottom:10px;font-size:15px}.module.info .marginBottom20{margin-bottom:20px}.customMasterHome .ui.card{margin:10px}.customMasterHome .ui.card .header{text-overflow:ellipsis;overflow:hidden;height:1.2em;white-space:nowrap}.module.masterData .customMasterFormBorder{padding:40px 0}.module.masterData .ui.button{padding:10px;font-size:1.4rem;line-height:1.4rem}.module.masterData .addItem{margin-top:20px}.masterData{padding:20px 0}.masterData .tableMasterDataHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.sellForm .react-datepicker{font-size:1.1em}.sellForm .react-datepicker__header{padding-top:.8em}.sellForm .react-datepicker__month{margin:.4em 1em}.sellForm .react-datepicker__day,.sellForm .react-datepicker__day-name{width:1.9em;line-height:1.9em;margin:.166em}.sellForm .react-datepicker__current-month{font-size:1.1em}.sellForm .react-datepicker__navigation{top:1em;line-height:1.7em;border:.45em solid transparent}.sellForm .react-datepicker__navigation--previous{border-right-color:#ccc;left:1em}.sellForm .react-datepicker__navigation--next{border-left-color:#ccc;right:1em}.tableDownload{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.tableDownload .th{padding:10px;font-size:12px;font-weight:600}.tableDownload .fileName{overflow-wrap:break-word;align-self:center;width:40%}.tableDownload .action,.tableDownload .createDate,.tableDownload .fileSize,.tableDownload .fileType{align-self:center;text-align:center;width:30%}.fileDownload{height:200px;overflow-y:auto}.ui.button.loading.clearBG{background-color:hsla(0,0%,100%,0)!important}.module.sellOrder{padding:20px 0}.module.sellOrder .header{width:80vw;position:fixed;z-index:100}.module.sellOrder .header .addSellOrder{width:45px;height:45px;background-color:#f9f9f9;border:1px solid #ccc;margin:0;padding:0;margin-top:1rem}.module.sellOrder .header .addSellOrder .icon{color:#ccc;font-size:28px;width:100%;height:100%;margin-top:10px!important}.module.sellOrder .header .tableSellOrderHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.module.sellOrder .header .tableSellOrderHeader .th{text-align:center;padding:10px;font-size:14px;font-weight:600}.module.sellOrder .header .tableSellOrderHeader .customerCode,.module.sellOrder .header .tableSellOrderHeader .isWaitingCustomerApprove,.module.sellOrder .header .tableSellOrderHeader .status{width:15%}.module.sellOrder .header .tableSellOrderHeader .accountNum,.module.sellOrder .header .tableSellOrderHeader .custGroup,.module.sellOrder .header .tableSellOrderHeader .drawingNo{width:10%}.module.sellOrder .header .tableSellOrderHeader .drawingRev,.module.sellOrder .header .tableSellOrderHeader .isNormalPriority,.module.sellOrder .header .tableSellOrderHeader .requestType{width:5%}.module.sellOrder .header .tableSellOrderHeader .action,.module.sellOrder .header .tableSellOrderHeader .customerName,.module.sellOrder .header .tableSellOrderHeader .pipeType{width:15%}.module.sellOrder .sellOrderContent{padding-top:13rem}.module.sellOrder .sellOrderContent .tableSellOrderContent{width:81vw;height:70vh;overflow:hidden;overflow-y:scroll;padding:10px 0}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr{display:inline-flex;width:80vw;color:#757575;border-bottom:1px solid #ccc}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover{background-color:#e6e6e6;color:#000}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnAdd:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnDelete:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnView:disabled{opacity:.4!important}.module.sellOrder .sellOrderContent .tableSellOrderContent .tableItem{padding:10px}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:last-child{border:none}.module.sellOrder .sellOrderContent .tableSellOrderContent .customerCode,.module.sellOrder .sellOrderContent .tableSellOrderContent .isWaitingCustomerApprove,.module.sellOrder .sellOrderContent .tableSellOrderContent .status{width:15%}.module.sellOrder .sellOrderContent .tableSellOrderContent .accountNum,.module.sellOrder .sellOrderContent .tableSellOrderContent .custGroup,.module.sellOrder .sellOrderContent .tableSellOrderContent .drawingNo{width:10%}.module.sellOrder .sellOrderContent .tableSellOrderContent .drawingRev,.module.sellOrder .sellOrderContent .tableSellOrderContent .isNormalPriority,.module.sellOrder .sellOrderContent .tableSellOrderContent .requestType{width:5%;text-align:center}.module.sellOrder .sellOrderContent .tableSellOrderContent .action,.module.sellOrder .sellOrderContent .tableSellOrderContent .customerName,.module.sellOrder .sellOrderContent .tableSellOrderContent .pipeType{width:15%}.module.sellOrder .sellOrderContent .tableSellOrderContent .status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px;text-align:center;font-size:medium}.module.sellOrder .sellOrderContent .tableSellOrderContent .REJECT,.module.sellOrder .sellOrderContent .tableSellOrderContent .SUBMIT{color:red}.module.sellOrder .sellOrderContent .tableSellOrderContent .PRE-APPROVE{color:#ecc900}.module.sellOrder .sellOrderContent .tableSellOrderContent .WAIT-CUSTOMER-APPROVE{color:#52b1ff}.module.sellOrder .sellOrderContent .tableSellOrderContent .COMPLETE{color:#87ff6a}.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnAdd,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnAdd:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnView,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnView:disabled{margin-right:5px;background-color:#cecece;color:#fffefe;opacity:1!important}.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete{margin:0}.module.sellOrder .sellOrderContent .sellOrderShowAllContent{text-align:center;width:80%;z-index:200;padding:0;display:inline;position:absolute}.module.sellOrder .sellOrderContent .sellOrderShowAllContent .ui.button{font-size:16px;background-color:inherit;color:#1b2c57}.module.sellOrder .sellOrderContent .sellOrderShowAllContent .ui.button .icon{margin-left:10px}.module.inputForm .editorInputHtml.drawingOrder{height:100px!important;border:1px solid #a8a8a8!important}.tableItem.status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px;text-align:center;font-size:medium}.tableItem.status .REJECT,.tableItem.status .SUBMIT{color:red}.tableItem.status .PRE-APPROVE{color:#ecc900}.tableItem.status .WAIT-CUSTOMER-APPROVE{color:#52b1ff}.tableItem.status .COMPLETE{color:#87ff6a}.tableItem.action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.tableItem.action .btnView:hover{background-color:#1e4af963;margin-right:5px;color:#fff}.tableItem.action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.tableItem.action .btnAdd:hover{background-color:#f4d52257;margin-right:5px;color:#fff}.tableItem.action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.tableItem.action .btnAdd:disabled,.tableItem.action .btnDelete:disabled,.tableItem.action .btnView:disabled{opacity:.4!important}.module.user .ui.button{font-size:1.2rem;line-height:16px}.module.transfer .desktop .header{background-color:#fff;border-radius:10px;padding:10px 15px}.module.transfer .desktop .header .titleText{font-size:2em;font-weight:bolder}.module.transfer .desktop .header .minWidth1{min-width:1em!important;font-size:1em!important}.module.transfer .desktop .header .minWidth1 .text{font-size:1.2em!important}.module.transfer .desktop .header .fieldTitle{font-size:1em}.module.transfer .mobileSize .header{background-color:#fff;border-radius:10px;padding:5px}.module.transfer .mobileSize .header .titleText{font-size:1.5dem;font-weight:bolder}.module.transfer .mobileSize .header .detailText{font-size:1.2em;font-weight:800}.module.transfer .mobileSize .header .minWidth1{min-width:1em!important;font-size:1em!important}.module.transfer .mobileSize .header .minWidth1 .text{font-size:1em!important}.module.transfer .mobileSize .header .fieldTitle{font-size:1em}.module.transfer .mobileSize .transferTable .dataRow{background-color:#fff;border-radius:10px;padding:5px 18px 0}.module.transfer .mobileSize .transferTable .dataRow .fieldName{font-size:.8em;word-break:break-word}.module.transfer .mobileSize .transferTable .dataRow .fieldValue{font-size:1em;font-weight:bolder;word-break:break-word}.module.transfer .modal .titleModal{margin-top:3vh;font-size:3em;line-height:5vh}.module.transfer .modal .btnAddText.transfer{font-size:2em}.itemRow{border:1.5px solid #e2e2e2;border-radius:10px;margin-top:10px;margin-bottom:10px;padding:5px 10px}.itemRow .itemTitle{font-size:1.3em}.itemRow .itemDetail{font-size:1.5em;word-break:break-word}.itemRow .modalQtyValue{width:15vh}.itemRow .btnAddText.transfer{background-color:#0f1a28;min-width:100px;height:50px;width:100%}.itemRow.number{margin-top:5vh;border:1.5px #e2e2e2;border-bottom-style:solid}.ui.button.btnScan{height:8vh;background:url(\"/assets/images/btn_scan.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnScan:disabled{background:url(\"/assets/images/btn_scan.png\")!important}.ui.button.btnAddManage{height:8vh;background:url(\"/assets/images/btn_add_mng.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnAddMobile{height:8vh;background:url(\"/assets/images/btn_addm.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnAddMobile:disabled{background-image:url(\"/assets/images/btn_addm.png\")!important;cursor:not-allowed}.ui.button.btnTransferMobile{height:8vh;background:url(\"/assets/images/btn_transfer.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnTransferMobile:disabled{background:url(\"/assets/images/btn_transfer.png\")!important;cursor:not-allowed;background-size:80%!important;background-repeat:no-repeat!important}.ui.button.btnBack{height:8vh;background:url(\"/assets/images/btn_back.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnCancel{height:8vh;background:url(\"/assets/images/btn_cancel.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnSubmitMobile{height:8vh;background-image:url(\"/assets/images/btn_submit.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnSubmitMobile:disabled{background-image:url(\"/assets/images/btn_submit.png\")!important;cursor:not-allowed;background-size:80%!important;background-repeat:no-repeat!important}.ui.button.btnClose{background:url(\"/assets/images/btn_close.png\");background-size:40%;background-repeat:no-repeat}.minWidth1Size{min-width:1vh}.minWidth1Size input{width:100%!important;min-width:1vh;font-size:.8em}.showStatus:hover+.hideStatus{display:block}.hideStatus{display:none}.fieldName{font-size:1em;font-weight:700;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.subFieldName{font-size:1.2em}.subFieldName,.titleName{text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.titleName{font-size:1em;font-weight:700}.subTitleName{font-size:1.2em;text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.itemRow{height:40vh;overflow-y:auto}.itemRow .modalQtyValue{font-size:1.4em!important;margin-right:1vh;width:15vw;text-align-last:center}.itemRow.detail{overflow-x:hidden}.previewField{font-size:.5em;text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.previewField.preview{font-size:.1em}.previewValueField{font-size:.9em}.previewValueField.preview{font-size:.8em}.previewValueField.preview.long{line-height:2vh;padding-top:1vh}.previewValueField.long{line-height:10px;margin-top:1vh}.printPreview{height:200px;margin-top:12px}.printPreview .detail .row{margin-bottom:-27px}.printPreview .detail.preview{margin-top:5vh}.printPreview .detail.preview .row{margin-top:-4vh}.rowTagItem{padding:10px;border:1px solid #ccc;margin-bottom:2vh;border-radius:10px}.fieldHeader{font-size:.8em;margin-bottom:-2px;text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.fieldHeader .textBold{font-weight:700}@media{.page-break{display:flex}}@media print{body,html{height:auto!important;overflow:initial!important;-webkit-print-color-adjust:exact}}@media print{.page-break{margin-top:1rem;margin-bottom:1rem;display:block;page-break-before:auto}}@page{margin:0}.module.setupDisplay p{color:#fff}.module.tabletask{height:100vh;padding:2vh}.module.tabletask p{color:#fff}.module.tabletask .tablelist{height:85vh;overflow-y:auto;overflow-x:hidden}.module.tabletask .itemInfo{padding:15px;border-style:groove;border-width:1px;border-radius:10px;cursor:pointer}.module.setupTable{padding:25px;border-radius:20px;background-color:hsla(0,0%,90%,.44)}.module.setupTable p{color:#fff}.module.tabletaskOnJob{height:100vh;padding:2vh}.module.tabletaskOnJob p{color:#fff}.module.tabletaskOnJob .itemsBoxDetail{height:20vh;margin-bottom:1vh}.module.tabletaskOnJob .itemsBoxDetail,.module.tabletaskOnJob .itemsJobDetail{background-color:hsla(0,0%,41%,.909);padding:10px;border-radius:10px;overflow-y:hidden;overflow-x:hidden}.module.tabletaskOnJob .itemsJobDetail{margin-top:1vh;height:38.5vh}.module.tabletaskOnJob .itemsJobDetail.normal{height:19vh}.module.tabletaskOnJob .itemsJobDetail .itemScrool{overflow-x:hidden;overflow-y:auto;height:95%}.module.tabletaskOnJob .itemsJobDetail .item{margin-bottom:1vh;padding:10px;border:1px solid #adadad;border-radius:10px;cursor:pointer}.module.tabletaskOnJob .itemsJobDetail .item.nonecursor{cursor:default}.module.tabletaskOnJob .itemsJobDetail.active{border:2.5px solid #fff}.module.tabletaskOnJob .manage{margin-top:1vh;height:81vh;border-radius:10px;overflow-x:hidden;overflow-y:hidden}.module.tabletaskOnJob .manage.active{border:2.5px solid #fff}.module.tabletaskOnJob .itemJobDetail{height:67%}.module.tabletaskOnJob .itemJobDetail,.module.tabletaskOnJob .itemJobTime{margin-top:1vh;overflow-x:auto;padding:20px;border-radius:10px;background-color:rgba(61,60,60,.909)}.module.tabletaskOnJob .itemJobTime{height:30%}.module.tabletaskOnJob .workerList{padding:20px;border-radius:10px;background-color:hsla(0,0%,41%,.909);height:100%}.module.tabletaskOnJob .workerList .itemsL{padding-top:10px;overflow-y:auto;overflow-x:hidden;min-height:20vh;max-height:64vh}.module.tabletaskOnJob .workerList .itemsL .item [tabindex]:focus{outline:2px solid #fff}.module.tabletaskOnJob .workerList .itemsL .item:focus{outline:1px solid #fff;background-color:red}.module.tabletaskOnJob .startJobItem{padding:4vh;padding-top:6vh;border-radius:10px;background-color:hsla(0,0%,41%,.909);margin-top:1vh;height:58.5vh}.displayLanding,.loginAdmin{text-align:center}.loginAdmin{display:inline-block;padding:7vh;background-color:#fff;border-radius:2vh}.waitingText{font-size:4em;color:#fff;margin-top:4vh}.borderJobTime{border:1px solid #fff}.textSizeCaption{font-size:1em}.displayWorker{width:100%;height:100%;margin-top:2vh}.displayWorker .setupView .ui.container{width:auto;margin-left:auto!important;margin-right:auto!important}.displayWorker .setupView .ui.container .modalHeaderText{text-align:center;margin-top:2vh;font-size:2em;margin-bottom:2vh;color:#fff}.displayWorker .setupView .ui.container .ui.form .field .ui.input input,.displayWorker .setupView .ui.container .ui.form .fields .field .ui.input input{text-align:center;font-size:2em;height:4vh!important;border-radius:2vh;min-height:1.714286em}.displayWorker .setupView .ui.container .ui.selection.dropdown{line-height:3vh;border-radius:2vh}.displayWorker .setupView .ui.container .ui.selection.dropdown .icon{line-height:3vh}.displayWorker .ui{width:auto;margin-left:auto!important;margin-right:auto!important}.displayWorker .ui .ui.form .field .ui.input input,.displayWorker .ui .ui.form .fields .field .ui.input input{text-align:center;font-size:2em;height:3vh;border-radius:1vh}.displayWorker .inputWithRef{text-align:center;font-size:1.2em;height:3vh;border-radius:1vh;width:100%}.display.modalInput .ui.form .field .ui.input input,.display.modalInput .ui.form .fields .field .ui.input input{padding:1vh!important;font-weight:200;text-align:center;font-size:4em;height:7vh;border-radius:1vh}.display.modalInput .inputHeaderTitle{padding-top:3.5vh;padding-bottom:3vh}.display.modalInput .inputHeaderTitle .modalHeaderText{font-size:4em}.display.modalInput .inputWithRef{text-align:center;font-size:4.5em;height:6vh;border-radius:1vh;width:100%}.itemTask{overflow-wrap:break-word;font-size:1em;line-height:1.5}.reportViewSummary .reportHeaderText{font-size:2em}.reportViewSummary .detailSummary{height:22vh;background-color:#adb8c738;padding:1vh}.reportViewSummary .detailSummary .itemTaskHeader{font-size:1.4em;font-weight:900}.reportViewSummary .detailWrapData{font-size:1em!important;height:12.3vh;overflow-y:auto;overflow-x:hidden;margin-top:.8vh}.subTitleDetailMode{overflow-x:auto;height:71vh;padding-top:2vh;padding-bottom:2vh}.subTitleDetailMode .itemsListMark{background-color:#dcdcdc}.subTitleDetailMode .itemTask{font-size:1.4em}.Tab:focus{outline:none;box-shadow:0 0 5px 2px #61c5fa!important}[tabindex]:focus{outline:2px solid #fff}.button:focus{background-color:red}.suggestUiForKeyboardMode .title{padding:10px 0;font-size:1.8rem}.suggestUiForKeyboardMode .layoutClick{margin:20px 0;border:1px solid gray;padding:20px;width:20vw}.titleItemText{font-size:1.4rem}.containerListPD{background-color:#fff;padding:16px 0;height:calc(100vh - 130px)}.containerListPD .wrapperNavPD{display:flex;justify-content:space-between;background-color:#fff;padding:8px}.containerListPD .wrapperNavPD .navBarRight{display:flex;align-items:center;justify-content:flex-end}.containerListPD .wrapperNavPD .navBarRight .avartarImage{display:flex;align-items:center;margin-right:32px}.containerListPD .wrapperNavPD .NavIcon{display:flex;align-items:center}.containerListPD .wrapperNavPD .NavIcon h1{margin:2px 10px 0 2px}.containerListPD .wrapperNavPD .NavIcon .sliders{width:56px;height:44px;margin-left:8px;display:flex;justify-content:center;align-items:center;cursor:pointer}.containerListPD .wrapperContent{background-color:#fff;padding:4px 0;margin:0 auto}.containerListPD .wrapperContent .wrapperContentFirstPart{padding-left:0!important}.containerListPD .wrapperContent .contentFirstPart{background-color:#fbfbfb;height:calc(100vh - 141px)}.containerListPD .wrapperContent .wrapperContentSecondPart{padding-right:0!important}.containerListPD .wrapperContent .contentSecondPart{background-color:#fff;padding:16px}.containerListPD .wrapperContent .contentSecondPart .detailPD{background-color:#fbfbfb;position:relative}.containerListPD .wrapperContent .contentSecondPart .printed{width:0;height:0;border-style:solid;border-width:0 40px 40px 0;border-color:transparent #ff851b transparent transparent;position:absolute;top:0;right:0}.containerListPD .wrapperContent .contentSecondPart .iconPrintDetail{position:absolute;right:2px;top:5px;font-size:12px;color:#fff}.containerListPD .wrapperContent .contentSecondPart .cardDetail{background-color:#fbfbfb;padding:4px;border-radius:4px}.containerListPD .wrapperContent .contentSecondPart .cardDetail .row .column{text-align:center}.containerListPD .wrapperContent .wrapperCardValue{cursor:pointer;border:1px solid #f1f2f2;border-radius:4px;margin-top:0!important;margin-bottom:4px}.containerListPD .wrapperContent .wrapperItemContent{padding:0 16px;overflow-x:auto;margin-top:10px}.containerListPD .wrapperContent .wrapperItemContent .buttons{width:100%;padding:0;margin-bottom:8px}.containerListPD .wrapperContent .wrapperItemContent .buttons .button{border:1px solid #f1f2f2}.containerListPD .wrapperContent .wrapperItemContent .cardVlue{padding-left:16px;position:relative}.containerListPD .wrapperContent .wrapperItemContent .cardVlue .printed{width:0;height:0;border-style:solid;border-width:0 50px 50px 0;border-color:transparent #ff851b transparent transparent;position:absolute;top:0;right:0}.containerListPD .wrapperContent .wrapperItemContent .cardVlue .print{position:absolute;right:7px;top:7px;font-size:14px;color:#fff}.containerListPD .wrapperContent .wapperPDList{max-height:calc(100% - 30px)}.containerListPD .wrapperContent .wapperPDList .lists{max-height:calc(100vh - 245px);width:100%;overflow:auto}.containerListPD .wrapperCardPD{height:calc(100vh - 345px);overflow:auto;display:flex;flex-direction:column;justify-content:flex-start;padding-top:1rem}.containerListPD .wrapperCardPD .wrapperDetaiCard{width:100%;margin-bottom:3rem;display:flex;align-items:center}.containerListPD .wrapperCardPD .wrapperDetaiCard div{width:100%}.containerListPD p{font-size:14px}.containerListPD .textVlue{font-size:14px;font-weight:500}.containerListPD .textJoblist{font-size:12px;text-align:center;color:#abb1b177}.containerListPD .wrapperBtn{display:flex;justify-content:center;margin-top:10px}.containerListPD .wrapperBtn .icon{cursor:pointer}.containerListPD .joblistHeader p{color:#cfcfcf}.containerListPD .joblistHeader hr{margin:4px 0 20px;height:1px;background-color:#cfcfcf;border:none}.containerListPD .textPDInTable{text-align:center;color:#cfcfcf;z-index:999}.containerListPD .tablelist{height:100%}.containerListPD .noDataText{text-align:center}.deviceListTable{margin-top:14px}.deviceListTable .detailList td{font-size:14px!important}.wrapperNavPD{display:flex;justify-content:space-between;background-color:#fff}.wrapperNavPD .navBarRight{display:flex;align-items:center;justify-content:flex-end}.wrapperNavPD .navBarRight .deviceName{font-size:18px;font-weight:700;margin-left:6px;margin-right:6px}.wrapperNavPD .navBarRight .avartarImage{display:flex;align-items:center;margin-right:32px}.wrapperNavPD .navBarRight .avartarImage .circular{cursor:pointer}.wrapperNavPD .NavIcon{display:flex;align-items:center}.wrapperNavPD .NavIcon .searchbar{display:flex;width:100%;align-items:center}.wrapperNavPD .NavIcon h1{margin:2px 10px 0 2px}.wrapperNavPD .NavIcon .sliders{width:56px;height:44px;margin-left:8px;display:flex;justify-content:center;align-items:center;cursor:pointer}.wrapperNavPD hr{margin:10px 10px 0;height:1px;background-color:#cfcfcf;border:none;width:100%}.wrapperNavPD .radioTogglePrint{width:200px;display:flex;align-items:flex-end;justify-content:flex-end}.containerOnGoingJob{padding:16px 0;max-height:calc(100vh - 100px);overflow-y:auto;overflow-x:hidden}.containerOnGoingJob h1{text-align:center;margin:24px 0}.containerOnGoingJob .ui.grid{margin:0!important}.containerOnGoingJob .displayNone{display:none!important}.containerOnGoingJob .gridCard{display:flex;justify-content:space-between}.containerOnGoingJob .gridCard .ui.disabled.dropdown,.containerOnGoingJob .gridCard .ui.disabled.input>input,.containerOnGoingJob .gridCard .ui.input:not(.disabled) input[disabled]{background:#fff!important}.containerOnGoingJob .cardListWork{padding:6px!important;text-align:center;margin-bottom:6px}.containerOnGoingJob .cardListWork .cardwithBorder{border-radius:4px;border:1px solid gray;padding:0 4px;padding-top:12px!important}.containerOnGoingJob .cardListWork .wrapperContentCard{padding:0!important;width:48%!important;margin-bottom:2px;margin-right:2px}.containerOnGoingJob .cardList{border:1px solid gray;padding:6px;text-align:center;width:100%;background:#fbfbfb;margin-bottom:12px;border-radius:4px}.containerOnGoingJob .cardList h2{margin:12px 0;text-align:center;width:100%}.containerOnGoingJob .cardList .unitJobName{background:#fff;border-radius:4px;border:1px solid #e7e7e7;padding:4px}.containerOnGoingJob .cardList .unitJobName .inputUnitJobName{background:#fff}.containerOnGoingJob .cardList .unitJobName .label{font-weight:400;display:flex;font-size:15px;align-items:center;justify-content:center;width:80px}.containerOnGoingJob .unitWork{background:#fff;border-radius:4px;padding:4px}.containerOnGoingJob .unitWork .inputUnitJobName{background:#fff;max-width:70%!important}.containerOnGoingJob .unitWork .label{font-weight:400;display:flex;font-size:15px;align-items:center;justify-content:center;width:80px}.containerOnGoingJob hr{margin:4px 0 20px;height:1px;background-color:#cfcfcf!important;border:none}.containerOnGoingJob .wrapperFooter{position:fixed;bottom:0;display:flex;justify-content:center;border-top:1px solid #cfcfcf;width:94%;padding:12px 0;background-color:#fff;flex-direction:column;align-items:center}.containerOnGoingJob .wrapperFooter .small{font-size:14px;border-radius:22px;padding:10px 14px;margin-top:12px}.containerOnGoingJob .wrapperFooter .small .icon{margin-right:6px!important}.ModalCheckInOutList .content{padding:42px 38px!important}.ModalCheckInOutList hr{margin:20px 0;height:1px;background-color:#cfcfcf!important;border:none}.ModalCheckInOutList .fourteen,.ModalCheckInOutList .fourteen .three{padding:0!important}.ModalCheckInOutList .fourteen .three .cardList{margin:0 8px 8px 0}.ModalCheckInOutList .fourteen .three .cardList .list{text-align:center;padding:0 4px}.ModalCheckInOutList .fourteen .three .cardList .list div{border-radius:8px;padding:8px;background-color:#e9e9e9;font-size:12px;margin-bottom:8px}.ModalCheckInOutList .footerModal{display:flex;justify-content:center}.ModalCheckInOutList .footerModal .wrapperButton{display:flex}.ModalCheckInOutList .footerModal .btnInModal{margin:0 auto;font-size:14px;border-radius:22px;padding:10px 14px}.ModalCheckInOutList .field,.ModalCheckInOutList .field .input{width:100%}@media only screen and (max-width:1440px){.containerOnGoingJob .inputUnitJobName{font-size:12px!important;width:50%!important}.containerOnGoingJob .ui.labeled.input>.label:not(.corner){font-size:12px!important}}@media only screen and (min-width:1441px){.containerOnGoingJob .inputUnitJobName{width:70%!important}}.contentSectionPDForm{margin-top:3rem;display:flex;justify-content:center;align-items:center;width:100%;flex-direction:column}.containerCreateUpdateProject{background:#fbfbfb;width:50%;border-radius:16px;padding:16px;margin:auto;border:1px solid #e9e9e9;margin-top:20px}.containerCreateUpdateProject .title{color:#fff}.containerCreateUpdateProject .wrapperProjectForm{margin-top:40px}.containerCreateUpdateProject .wrapperProjectForm p{color:#fff}.containerCreateUpdateProject .formProject{overflow:auto;padding:16px}.containerCreateUpdateProject button{width:100px}.containerCreateUpdateProject .footerForm{display:flex;justify-content:center}.containerCreateUpdateProject .footerForm button{width:100px;background:#48bb78;color:#fff}.containerCreateUpdateProject .footerForm button:hover{background:#2a794b;color:#fff}.containerCreateUpdateProject .footerForm .backPage{background:#f56565;color:#fff;width:100px}.containerCreateUpdateProject .footerForm .backPage:hover{background:#feb2b2;color:#fff}.wrapperCardModal{background:#edf2f7;border-radius:4px;margin-bottom:4px!important}.wrapperCardModal button{padding:1px 2px!important;margin-top:4px!important}@media only screen and (min-width:426px) and (max-width:1024px){.containerCreateUpdateProject{width:80%}}@media only screen and (max-width:425px){.containerCreateUpdateProject{width:95%}}.module.loginPD{text-align:center;margin:20px;margin-top:-50px;padding:38px 38px 24px;border:1px solid #4299e1;border-radius:8px;background:#fff}.module.loginPD.withborder{border:1px solid #c5c9ca;background-color:#fff;margin-top:10px;padding-top:0;padding-bottom:20px;margin:auto;width:50%}.module.loginPD .logoImage img{width:45rem;margin:0;display:inline-flex}.module.loginPD .loginButton{padding-top:30px;background-color:#fff;border-color:#c5c9ca}.module.loginPD input{border-radius:8px}.module.loginPD input:focus .module.loginPD input:active .module.loginPD input:hover{border-color:#4299e1}.module.loginPD .headerText{font-size:2.5rem;font-weight:bolder;padding-bottom:4vh}.module.loginPD .wrapperReset{display:flex;justify-content:end}.module.loginPD .wrapperReset .resetText{text-align:right;opacity:.5!important;font-size:1rem;cursor:pointer}.module.loginPD .signInText{font-size:1.2rem;font-weight:700;padding-bottom:1vh}.modalHeaderText p{font-size:16px}.wrapperContent p{font-size:14px}.contentDetail{margin-top:6px}.contentDetail .column{display:flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:center!important}@media print{.buttonPrint{display:none!important}.dimmed{display:flex;justify-content:center;margin-top:3rem}}.containerListPDAX{background-color:#fff;padding:16px 0;height:calc(100vh - 130px)}.containerListPDAX .wrapperNavPD{display:flex;justify-content:space-between;background-color:#fff;padding:8px}.containerListPDAX .wrapperNavPD .navBarRight{display:flex;align-items:center;justify-content:flex-end}.containerListPDAX .wrapperNavPD .navBarRight .avartarImage{display:flex;align-items:center;margin-right:32px}.containerListPDAX .wrapperNavPD .NavIcon{display:flex;align-items:center}.containerListPDAX .wrapperNavPD .NavIcon h1{margin:2px 10px 0 2px}.containerListPDAX .wrapperNavPD .NavIcon .sliders{width:56px;height:44px;margin-left:8px;display:flex;justify-content:center;align-items:center;cursor:pointer}.containerListPDAX .wrapperContent{background-color:#fff;padding:4px 0;margin:0 auto}.containerListPDAX .wrapperContent .wrapperContentFirstPart{padding-left:0!important}.containerListPDAX .wrapperContent .contentFirstPart{background-color:#fbfbfb;height:calc(100vh - 196px)}.containerListPDAX .wrapperContent .wrapperContentSecondPart{padding-right:0!important}.containerListPDAX .wrapperContent .contentSecondPart{background-color:#fff;padding:16px;height:100%}.containerListPDAX .wrapperContent .contentSecondPart .wrapperContentInSecond{height:100%;display:flex;flex-direction:column;justify-content:space-between}.containerListPDAX .wrapperContent .contentSecondPart .btnAx{display:flex;justify-content:flex-end}.containerListPDAX .wrapperContent .contentSecondPart .detailPD{background-color:#fbfbfb;position:relative}.containerListPDAX .wrapperContent .contentSecondPart .printed{width:0;height:0;border-style:solid;border-width:0 40px 40px 0;border-color:transparent #ff851b transparent transparent;position:absolute;top:0;right:0}.containerListPDAX .wrapperContent .contentSecondPart .iconPrintDetail{position:absolute;right:2px;top:5px;font-size:12px;color:#fff}.containerListPDAX .wrapperContent .contentSecondPart .cardDetail{background-color:#fbfbfb;padding:4px;border-radius:4px}.containerListPDAX .wrapperContent .contentSecondPart .cardDetail .row .column{text-align:center}.containerListPDAX .wrapperContent .wrapperCardValue{cursor:pointer;border:1px solid #f1f2f2;border-radius:4px}.containerListPDAX .wrapperContent .mainwrapperList{display:flex;height:95%;flex-direction:column;justify-content:space-between}.containerListPDAX .wrapperContent .mainwrapperList .btnAx{display:flex;justify-content:center}.containerListPDAX .wrapperContent .wrapperItemContent{padding:0 16px;overflow-x:auto;margin-top:10px;height:100%;display:flex;flex-direction:column;justify-content:flex-start;flex-wrap:nowrap}.containerListPDAX .wrapperContent .wrapperItemContent .itemValue{padding:0}.containerListPDAX .wrapperContent .wrapperItemContent .itemValue .wrapperCheckBox{display:flex;justify-content:center;align-items:center}.containerListPDAX .wrapperContent .wrapperItemContent .cardVlue{padding-left:16px;position:relative}.containerListPDAX .wrapperContent .wrapperItemContent .cardVlue .printed{width:0;height:0;border-style:solid;border-width:0 50px 50px 0;border-color:transparent #ff851b transparent transparent;position:absolute;top:0;right:0}.containerListPDAX .wrapperContent .wrapperItemContent .cardVlue .print{position:absolute;right:7px;top:7px;font-size:14px;color:#fff}.containerListPDAX .wrapperCardPD{height:calc(100vh - 345px);overflow:auto;display:flex;flex-direction:column;justify-content:flex-start;padding-top:1rem}.containerListPDAX .wrapperCardPD .wrapperDetaiCard{width:100%;margin-bottom:3rem;display:flex;align-items:center}.containerListPDAX .wrapperCardPD .wrapperDetaiCard div{width:100%}.containerListPDAX p{font-size:14px}.containerListPDAX .textVlue{font-size:14px;font-weight:500}.containerListPDAX .textJoblist{font-size:12px;text-align:center;color:#abb1b177}.containerListPDAX .wrapperBtn{display:flex;justify-content:center;margin-top:10px}.containerListPDAX .wrapperBtn .icon{cursor:pointer}.containerListPDAX .joblistHeader p{color:#cfcfcf}.containerListPDAX .joblistHeader hr{margin:4px 0 20px;height:1px;background-color:#cfcfcf;border:none}.containerListPDAX .textPDInTable{text-align:center;color:#cfcfcf;z-index:999}.containerListPDAX .tablelist{height:100%}.containerListPDAX .noDataText{text-align:center}", ""]);

// exports


/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"OK","cancel":"Cancel","back":"Back","welcome":"Welcome","hello":"Hello","somethingWrong":"Something Went Wrong, Please Try Again.","yourData":"Confirm Your Information.","validateError":"Validate error, Please fill in all require data.","validateItemNoError":"Please fill a item number","validateCommentError":"Please enter a comment","attachError":"Upload error, Please choose file","squareInch":"SQUARE INCH","version":"Version","logout":"Log out","npiSystem":"NPI System","pageNotFound":"Page not found, Please re-check your url again.","unauthen":"Unauthorized, Please contact administrator for request access.","success":"Success","fail":"Fail","itemCode":"Item Code","itemStatus":"Item Status","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","right":"Right","left":"Left","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"Last Update by","create":"Create","view":"View","update":"Update","value":"Value","createFail":"Create Fail","updateFail":"Update Fail","upload":"Upload","comment":"Comment","close":"Close","confirm":"Confirm","save":"Save","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"Delete By","print":"Print","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"Break, Please Scan ID for Start","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":"Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List","drawingInfoTitle":"Drawing Search","itemNo":"Item Number (FG)","drawingLogin":"Drawing Login","":""}}

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"Sign in with o365","title":"Login","logout":"Logout","loginFail":"Login Fail","getUserInfoFail":"Get User Info Fail From Microsoft Graph"}}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"Search","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"Search","showLess":"Show Less","showAll":"Show All"}}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports = {"header":{"material":"Material","special":"Special","assambly":"Assambly"}}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"Start Date","endDate":"End Date","user":"User","action":"Action","count":"Count","topActionByUser":"Top action by user","version":"Version"}}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports = {"menu":{"drawingSystem":"Drawing System","drawingSystem2":"Drawing System New","about":"About","master":"Master Data","sellOrder":"Request Drawing","user":"Users","settings":"Settings","systemSettings":"System"}}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data"}}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"Name","empId":"Employee Id","isAdmin":"Is Admin","isNpiAdmin":"Is Npi","manage":"Manage Users","costCenterName":"Cost Center","viewList":"View Users","manageNpi":"Manage NPI admin","manageAdmin":"Manage Admin","edit":"Edit","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"Back to List"}}

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports = {"master":{"setings":"Settings"}}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports = {"warehouse":{"title":"Title","titleHome":"QR Tag","listTitle":"List Order","createTitle":"Transfer","imsTransferNo":"IMS Transfer No","from":"From","to":"To","date":"Date","createBy":"Create by","status":"Status","statusAX":"Complete on AX","fromWarehouse":"From Warehouse","toWarehouse":"To Warehouse","select":"Select","itemId":"Item No","itemName":"Item Name","onHandQTY":"On Hand Qty","requestQty":"Request Qty","qty":"Qty","receiveQty":"Receive Qty","unitId":"Unit","transfer":"Transfer","receiveTransfer":"Receive Transfer","batch":"Batch","searchItemNoName":"Search Item No. / Item Name","confirmTransfer":"Are you sure to create to transfer request?","successfullyTransfer":"Successfully Transfer Request","rmtag":"RM Tag","pdtag":"PD Tag","placeholderSearch":"Search Purchase Order / Invoice Account","purchaseNo":"Purchase No","packingSlipId":"Packing Slip","poNo":"PO No","invoiceAccount":"Invoice Account","receivedDate":"ReceiveDate","venderName":"Vender Name","purchaseType":"Purchase Type","approvalStatus":"Approval Status","deliveryDate":"Delivery Date","purchaseStatus":"Purchase Status","itemNo":"Item No","venderBatch":"Vender Batch","procurementCategory":"Procurement Category","unit":"Unit","tagUnit":"Tag (Unit)","purchaseOrderStatus":"Purchase Order Status","vendorAccount":"Vendor Account","inventLocationId":"InventLocation","cigInternalReference":"CIG Internal Reference","prodId":"Prod","prodPoolId":"Prod Pool","schedStart":"Date Start","schedEnd":"Date End"}}

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

module.exports = {"display":{"tableName":"Table Name","resource":"Resource","displayName":"Display Name","stationName":"Station Name","jobList":"Job List","jobListAssign":"JOB LIST ASSIGN","manageJob":"MANAGE JOB","noItems":"No Items","inputPd":"Input PD","qty":"Qty","inventLocationId":"Invent Location","productName":"Product Name","workerList":"Worker List","noWorker":"No Worker","pd":"PD","done":"Done","inputWorker":"Input Worker","":"","settingsDevice":"Setup Device","productionOrder":"Production Order","cigInternalRef":"CIG Internal Reference","detail":"Detail","dateNow":"Date (Now)","timeNow":"Time (Now)","plan":"Plan","remaining":"Remaining","spendingTime":"Spending Time","workerId":"Id","workerName":"Name","itemNo":"Item No.","itemName":"Item Name","quantity":"Quantity","journal":"Journal","station":"Station","reportAsFinish":"Report as Finish","picking":"Picking","jobCard":"Job Card","wareHouse":"WareHouse","goodQuantity":"Good Quantity","line":"Line","proposal":"Proposal","consumption":"Consumption","remainder":"Remainder","scrap":"Scrap","addScrap":"Add Scrap","finish":"Finish","scrapNo":"Scrap No.","description":"Description","errorQty":"Error Qty.","errorScrap":"Error Scrap","breakDown":"Break Down","otherProblem":"Other Problem","changeOnMaterial":"Change On Material","changeOnPicking":"Change On Picking","changeOnOther":"Change on site/warehouse/location","other":"other","faultReport":"Fault Report","addBreakDown":"Add Break Down","breakDownReportAsFinish":"Break Down Report as Finish","breakDownWithoutReport":"Break Down Without Report","breakDownCause":"Break Down Cause","startTime":"Start Time","endTime":"End Time","setup":"Setup","process":"Process","start":"Start","end":"End","mins":"minutes","hours":"hours","next":"Next","worker":"Worker","setWorker":"Set Worker","addWorker":"Add Worker","material":"Material","onHandQty":"On hand","unit":"Unit","materialWarehouse":"Material Warehouse","materialQty":"Material Qty","changeMaterial":"Change Material","addMaterial":"Add Material","addPD":"Add PD","setPD":"Set PD","addRM":"Add RM"},"displayModalMsg":{"removeTableList":"confirm to remove table","":""}}

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

module.exports = {"pd":{"search":"Search PD No","clear":"Clear","notPrint":"Not Print","noData":"No Data","print":"Print","pdList":"PD Lists","jobList":"Job Lists","pdListAx":"PD Lists for AX","deviceListSetting":"Device List Setting","logout":"Logout","yesterday":"Yesterday","today":"Today","tomorrow":"Tomorrow","qty":"QTY","startDate":"Start Date","endDate":"End Date","sendToAX":"Send to AX","sendToAXMulti":"Send Selected to AX","pdNo":"PD No","jobNo":"Job No","itemNo":"Item No","jobType":"Job Type","jobStatus":"Job Status","qtyGood":"Qty Good","qtyError":"Qty Error","totalTime":"Total Time","timeUnitMins":"Mins"},"device":{"deviceLists":"List Device","create":"Create","edit":"Edit","update":"Update","view":"View","device":"Device","submit":"Submit","name":"Name","picking":"Picking","jobCard":"Job Card","reportAsFinished":"Report As Finished","description":"Description","onGoingJob":"On Going Job","worker":"Worker","checkinout":"Check in/out","scanQr":"Scan Qr Code","inputQtyGood":"Input Good Qty equel or no more than","inputError":"Input Error QTY (if there is no error input 0)","PressEnterToStart":"Press enter to start","PressEnterToEnd":"Press enter to end","empId":"Employee ID"}}

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"ตกลง","cancel":"ยกเลิก","back":"กลับ","welcome":"ยินดีต้อนรับ","hello":"สวัสดี","somethingWrong":"เกิดความผิดพลาด ลองใหม่อีกครั้ง","yourData":"ข้อมูลที่จะทำการบันทึก","validateError":"ไม่สามารถทำรายการต่อไปได้ กรุณากรอกข้อมูลให้ครบถ้วน","validateItemNoError":"Please fill a item number","validateCommentError":"กรุณาแสดงความคิดเห็น","attachError":"ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากท่านยังไม่ได้ทำการเลือกไฟล์","squareInch":"SQUARE INCH","version":"เวอร์ชัน","logout":"ออกจากระบบ","npiSystem":"ระบบ NPI","pageNotFound":"ไม่พบข้อมูล กรุณาตรวจสอบ url อีกครั้ง","unauthen":"ไม่มีสิทธิเข้าใช้งาน, กรุณาติดต่อเจ้าหน้าที่ เพื่อขอสิทธิใช้งาน","success":"สำเร็จ","fail":"ไม่สำเร็จ","itemCode":"รหัสรายการ","itemStatus":"สถานะ","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","left":"Left","right":"Right","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"แก้ไขโดย","create":"เพิ่ม","view":"ดูรายละเอียด","update":"แก้ไข","value":"Value","createFail":"บันทึกไม่สำเร็จ","updateFail":"ปรับปรุงไม่สำเร็จ","upload":"อัพโหลด","comment":"ส่งข้อความ","close":"ปิด","confirm":"ยืนยัน","save":"บันทึก","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"ลบโดย","print":"พิมพ์","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"อยู่ระหว่างพัก กรุณาแตะบัตรเพื่อเริ่มการทำงานอีกครั้ง","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":" Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List","drawingInfoTitle":"ค้นหา Drawing","itemNo":"Item Number (FG)","drawingLogin":"Drawing Login","":""}}

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"ลงชื่อเข้าใช้ด้วย o365","title":"ลงชื่อเข้าใช้","logout":"ลงชื่อออก","loginFail":"ลงชื่อเข้าใช้งาน ไม่สำเร็จ","getUserInfoFail":"ดึงข้อมูลจาก Microsoft Graph ไม่สำเร็จ"}}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"ย้อนกลับ","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"วันที่เริ่มต้น","endDate":"วันที่สิ้นสุด","user":"ผู้ใช้งาน","action":"สถานะ","count":"จำนวน","topActionByUser":"ผู้ใช้งานที่ใช้งานสูงสุด ในแต่ละสถานะ","version":"เวอร์ชัน"}}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports = {"menu":{"drawingSystem":"ระบบบันทึก Drawing","drawingSystem2":"ระบบบันทึก Drawing 2","about":"รายละเอียด","master":"ข้อมูล เริ่มต้น","sellOrder":"ระบบันทึกแบบ Sale","user":"ผู้ใช้งาน","settings":"ตั้งค่า","systemSettings":"ระบบ"}}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล"}}

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"ชื่อ","empId":"รหัสพนักงาน","isAdmin":"สิทธิ Admin","isNpiAdmin":"สิทธิ Npi","manage":"รายละเอียด ผู้ใช้งาน","costCenterName":"หน่วยงาน","viewList":"รายละเอียดผู้ใช้งาน","manageNpi":"จัดการ สิทธิ NPI","manageAdmin":"จัดการ สิทธิ Admin","edit":"แก้ไข","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"กลับหน้า รายละเอียดผู้ใช้งาน"}}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports = {"master":{"setings":"การตั้งค่า"}}

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

module.exports = {"warehouse":{"title":"Title","titleHome":"QR Tag","listTitle":"List Order","createTitle":"Transfer","imsTransferNo":"IMS Transfer No","from":"From","to":"To","date":"Date","createBy":"Create by","status":"Status","statusAX":"Complete on AX","fromWarehouse":"From Warehouse","toWarehouse":"To Warehouse","select":"Select","itemId":"Item No","itemName":"Item Name","onHandQTY":"On Hand Qty","requestQty":"Request Qty","qty":"Qty","receiveQty":"Receive Qty","unitId":"Unit","transfer":"Transfer","receiveTransfer":"Receive Transfer","batch":"Batch","searchItemNoName":"Search Item No. / Item Name","confirmTransfer":"Are you sure to create to transfer request?","successfullyTransfer":"Successfully Transfer Request","rmtag":"RM Tag","pdtag":"PD Tag","placeholderSearch":"Search Purchase Order / Invoice Account","purchaseNo":"Purchase No","packingSlipId":"Packing Slip","poNo":"PO No","invoiceAccount":"Invoice Account","receivedDate":"ReceiveDate","venderName":"Vender Name","purchaseType":"Purchase Type","approvalStatus":"Approval Status","deliveryDate":"Delivery Date","purchaseStatus":"Purchase Status","itemNo":"Item No","venderBatch":"Vender Batch","procurementCategory":"Procurement Category","unit":"Unit","tagUnit":"Tag (Unit)","purchaseOrderStatus":"Purchase Order Status","vendorAccount":"Vendor Account","inventLocation":"Invent Location","cigInternalReference":"CIG Internal Reference","prodId":"Prod","prodPoolId":"Prod Pool","schedStart":"Date Start","schedEnd":"Date End"}}

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

module.exports = {"display":{"tableName":"Table Name","resource":"Resource","displayName":"ชื่อหน้าจอ","stationName":"ชื่อเครื่อง","jobList":"รายการงาน","jobListAssign":"รายการงาน","manageJob":"จัดการงาน","noItems":"ไม่ม่รายการ","inputPd":"กรอก PD","qty":"จำนวน","inventLocationId":"Invent Location","productName":"ชื่อผลิตภัณฑ์","workerList":"รายชื่อพนักงาน","noWorker":"ไม่มีพนักงาน","pd":"PD","done":"Done","inputWorker":"Input Worker","":"","settingsDevice":"ตั้งค่าอุปกรณ์","cigInternalRef":"CIG Internal Reference","productionOrder":"Production Order","detail":"รายละเอียด","dateNow":"วันที่ (ปัจจุบัน)","timeNow":"เวลา (ปัจจุบัน)","plan":"กำหนด","remaining":"คงเหลือ","spendingTime":"เวลาที่ใช้ไป","workerId":"เลขประจำตัว","workerName":"ชื่อ","itemNo":"รหัสสินค้า","itemName":"ชื่อสินค้า","quantity":"จำนวนสั่งผลิต","journal":"Journal","station":"Station","reportAsFinish":"Report as Finish","picking":"Picking","jobCard":"Job Card","wareHouse":"WareHouse","goodQuantity":"Good Quantity","line":"Line","proposal":"Proposal","consumption":"Consumption","remainder":"Remainder","scrap":"Scrap","addScrap":"เพิ่มรายการของเสีย","finish":"เสร็จสิ้น","scrapNo":"รหัสของเสีย","description":"รายละะอียด","errorQty":"Error Qty.","errorScrap":"จำนวนของเสีย","breakDown":"Break Down","otherProblem":"Other Problem","changeOnMaterial":"Change On Material","changeOnPicking":"Change On Picking","changeOnOther":"Change on site/warehouse/location","other":"other","faultReport":"Fault Report","addBreakDown":"Add Break Down","breakDownReportAsFinish":"Break Down Report as Finish","breakDownWithoutReport":"Break Down Without Report","breakDownCause":"Break Down Cause","startTime":"เวลาเริ่มต้น","endTime":"เวลาสิ้นสุด","setup":"ตั้งเครื่อง","process":"ดำเนินการ","start":"เริ่ม","end":"จบ","next":"ถัดไป","mins":"นาที","hours":"ชั่วโมง","worker":"พนักงาน","setWorker":"ตั้งค่าพนักงาน","addWorker":"เพิ่มพนักงาน","material":"Material","onHandQty":"On hand","unit":"Unit","materialWarehouse":"Material Warehouse","materialQty":"Material Qty","changeMaterial":"Change Material","addMaterial":"Add Material","addPD":"Add PD","setPD":"Set PD","addRM":"Add RM"},"displayModalMsg":{"removeTableList":"confirm to remove table"}}

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports = {"pd":{"search":"ค้นหาเลขที่เอกสาร (PD)","clear":"ล้าง","notPrint":"ไม่ได้ปริ๊นท์","noData":"ไม่พบข้อมูล","print":"พิมพ์","pdList":"รายการเอกสาร","jobList":"รายการของงาน","pdListAx":"รายการเอกสาร AX","deviceListSetting":"จัดการอุปกรณ์","logout":"ลงชื่อออก","yesterday":"เมื่อวาน","today":"วันนี้","tomorrow":"พรุ่งนี้","qty":"จำนวน","startDate":"วันที่เริ่มงาน","endDate":"วันที่สิ้นสุด","sendToAX":"ส่งรายการไปที่ระบบ AX","sendToAXMulti":"ส่งรายการที่เลือกไปที่ระบบ AX","pdNo":"เลขที่เอกสาร","jobNo":"เลขที่ของงาน","itemNo":"เลขที่รายการ","jobType":"ประเภทของงาน","jobStatus":"สถานะของงาน","qtyGood":"จำนวนงานที่สำเร็จ","qtyError":"จำนวนงานที่เกิดปัญหา","totalTime":"เวลาทำงาน","timeUnitMins":"นาที"},"device":{"deviceLists":"รายการของอุปกรณ์","create":"สร้าง","edit":"แก้ไข","update":"แก้ไข","view":"ดูรายการ","device":"อุปกรณ์","submit":"ยืนยัน","name":"ชื่อ","picking":"Picking","jobCard":"Job card","reportAsFinished":"Report As Finished","description":"รายละเอียด","onGoingJob":"งานที่กำลังทำ","worker":"คนทำงาน","checkinout":"เช็คอิน/เช็คเอาท์","scanQr":"สแกนคิวอาร์โค้ด","inputQtyGood":"ระบุจำนวนงานที่สำเร็จ ไม่เกิน","inputError":"จำนวนข้อผิดพลาด (หากไม่มีข้อผิดพลาดระบุ 0)","PleaseEnterToStart":"กด Enter เพื่อเริ่มต้นงาน","PleaseEnterToEnd":"กด Enter เพื่อสิ้นสุดงาน","empId":"รหัสพนักงาน"}}

/***/ })

},[254]);


// WEBPACK FOOTER //
// app.3b2710b59839aa2385cc.js